import Vue from 'vue'
import Vuex, {ActionContext, MutationPayload} from 'vuex'
import axios from "axios";
import gorevYoneticisi from "@/plugins/uyap-plugin/store/modules/GorevYoneticisi";
import {
    AppState,
    AppStatus,
    KimlikUyusmazligiSebebi,
    ManifestResponse,
    UyapEngeli,
    UyapGirisAsamasi,
    UyapStatusMessage
} from '@/types';
import VueSocketIOExt from 'vue-socket.io-extended';
import {io} from 'socket.io-client';
import app from "@/main";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {
    oturumKimligiUyusuyor,
    hesabaAitKartiSec,
    tcknNormalize,
    kimlikUyusmazligiKancasiniAyarla,
    KIMLIK_UYUSMAZLIGI_MESAJI,
    HESAP_TCKN_BILINMIYOR_MESAJI,
    kimlikHatasi,
    sikiModuAyarla,
    hesapTcknKaynagiAyarla
} from "@/store/oturumKimligi";
import {isletimSistemiBildirimi, uyariSesi} from "@/plugins/kritikUyari";
import {
    kotaUyarisiKancasiniAyarla,
    devreKesiciKancasiniAyarla,
    durumMesajiKancasiniAyarla,
    baglantiKurtarmaKancasiniAyarla,
    devreKesiciAcikMi,
    devreKesiciSifirla,
    DurumMesajiTipi
} from "@/plugins/uyap-plugin/BaglantiKurtarma";
import {IslemDurum, PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {eicraproBekleniyorHatasiMi} from "@/utils/eicraproBaglantisi";
import {
    BOT_GIRIS_BEKLEMELERI_MS,
    BotBeklemeSebebi,
    botBeklemeDurdurmadaSilinirMi,
    botGirisiIzinVerilirMi,
    DEVRALMA_YOKLAMA_ARALIK_MS,
    kodtanSebebe,
    KURTARMA_DOGRULAMA_ARALIK_MS
} from "@/utils/botBekleme";
import {tekUcusluBirlestir} from "@/utils/birlestirici";
import {
    aktifKimlikActions,
    aktifKimlikGetters,
    aktifKimlikMutations,
    aktifKimlikState,
    botBeklemeyiAyarla,
    oturumDeposu,
    oyuncuyuDuraklat
} from "@/store/aktifKimlik";
import {
    UyapEngelBilgisi,
    UyapEngelKaynagi,
    uyapEngelHatasiMi,
    uyapEngelKancasiniAyarla,
    uyapEngelKapisiHatasi,
    uyapEngelKilidiAktifMi,
    uyapEngelKilidiniGeriYukle,
    uyapEngelKilidiniKaldir
} from "@/plugins/uyap-plugin/UyapEngeli";
import {
    UYAP_ENGEL_FREN_YOLU,
    UYAP_ENGEL_FREN_ZAMAN_ASIMI_MS,
    UYAP_ENGEL_METINLERI,
    UYAP_ENGEL_PANEL_BILDIRIM_SN,
    baslatIsteginiIsle,
    engelMesajiniTemizle,
    engelPanelMesaji,
    playerOlayiKarari,
    uyapEngeliniOku,
    uyapEngeliniSil,
    uyapEngeliniYaz
} from "@/utils/uyapEngeli";
import {uyapEngeliBaslatOnayi} from "@/utils/uyapEngeliOnayi";

const socket = io('https://imza.eicrapro.com:3000');
Vue.use(VueSocketIOExt, socket);
Vue.use(Vuex);

// connectToUyap için in-flight kilidi: eşzamanlı çağrılar (Bağlan butonu, socket
// eventi, health check) aynı denemeyi paylaşır; geç biten eski bir deneme yeni
// kurulmuş bağlantıyı false'a ezemez.
let connectToUyapPromise: Promise<void> | null = null;

// Ardışık başarısızlıkta tik atlayarak geri çekilme için.
let healthTikSayaci = 0;

export const HEALTH_CHECK_ARALIK_MS = 30000;

// Kart gözlemcisi. Yoklama yerel imzalama uygulamasına gider (127.0.0.1:5975),
// UYAP'a değil; sıklık ban riski taşımaz. Kart takılıyken sık sormanın faydası
// olmadığı için periyot uzar. Tik sabit, periyot tik atlanarak uygulanır.
export const KART_YOKLAMA_TIK_MS = 1000;
export const KART_YOKLAMA_KART_YOK_MS = 3000;
// Kart takılıyken uzun: bu uç kart kullanıldıktan sonra ~4 sn sürüyor ve imzalama
// ile aynı token'ı meşgul ediyor. Buradaki tek amaç kart çıkarılmasını görmek.
export const KART_YOKLAMA_KART_VAR_MS = 60000;

let kartGozlemciTimer: number | null = null;
let sonKartYoklamasi = 0;

// Otomatik giriş geri çekilmesi. Kurtarmanınkinden (3/15/30 sn) BİLEREK daha
// uzun başlar: kurtarma bir görevin ortasında kullanıcı beklerken çalışır,
// otomatik giriş ise arka planda kimse beklemezken. Login spam bir kez IP
// yasağına yol açtı; arka plandaki bir denemenin acelesi yok.
export const OTO_GIRIS_BEKLEMELERI_MS = BOT_GIRIS_BEKLEMELERI_MS;
// Art arda bu kadar başarısızlıktan sonra otomatik giriş susar. Yeniden
// başlaması için ya kart çıkarılıp takılmalı ya da kullanıcı "Bağlan"a basmalı.
export const OTO_GIRIS_MAX_DENEME = 5;

let otoGirisBasarisizSayisi = 0;
let otoGirisSonrakiDenemeZamani = 0;
// Son giriş denemelerinin zamanları (saatlik sınır için); otomatik ve bot girişi AYNI sayaçları paylaşır.
let botGirisZamanlari: number[] = [];
// Bot yeniden bağlanması tek uçuşta: dongu her 5 sn'de çağırsa da paralel giriş açılmaz.
let botGirisUcusu: Promise<void> | null = null;
// Tarayıcı kaynaklı kurtarma isteğinde "bağlı" bayrağının canlı doğrulaması: tek uçuş. Tarayıcı
// 3/15/30 sn'de bir yeniden yayınladığı için GEÇERLİ çıkan sonuç KURTARMA_DOGRULAMA_ARALIK_MS boyunca
// yeniden yoklanmaz (tarayıcının bayrağı düzeltilirken UYAP'a yoklama yağmaz).
let kurtarmaDogrulamaUcusu: Promise<boolean> | null = null;
let sonGecerliKurtarmaDogrulamasi: number | null = null;
// UYAP oturumunun en son yoklandığı an (uyapOturumuGecerliMi, HER yoldan), o yoklamanın OLUMSUZ olup
// olmadığı ve oturum devralma yoklamasının tek uçuşu (oturumuDevralmayiDene). Olumsuz sonuç KALICIDIR:
// UYAP'ta oturum kendiliğinden doğmaz (yalnız bizim girişimiz açar), bu yüzden devralma yoklaması yeni bir
// tetikleyici (kart takılması, updateToken: devralmaYoklamasiniAc) gelene kadar yinelenmez.
let sonOturumYoklamasi = 0;
let oturumYoklamasiOlumsuz = false;
let devralmaUcusu: Promise<DevralmaSonucu> | null = null;
// uyapOturumuGecerliMi'nin SON yoklaması UYAP'ın insan doğrulaması uyarısına (engel) çarptı mı. Engel "oturum yok"
// DEĞİLDİR: çağıranlar (oturumuDevralmayiDene, connectToUyap, fastLoginUyap, checkUyapSessionNew,
// tarayiciKurtarmasiniSurdur) bu yan kanaldan okur; bool dönüş tipi (6 çağıran, mevcut spec'ler) değişmez.
let sonYoklamaEngelliydi = false;
// `player` olaylarının sırası: playerOlayiniIsle'nin asenkron `kaldir-uygula` kolu beklerken daha yeni bir olay
// işlendiyse bayat 'oto' UYGULANMAZ.
let playerOlaySirasi = 0;
// Görev listesi yenilemesi: devir patlamaları tek GET /api/v1/task olur (utils/birlestirici.ts).
let gorevTazeleBirlestirici: (() => Promise<void>) | null = null;

/**
 * Başarısız sayılmayan (insan gerektiren ya da eİcraPro kimliği beklenen) bir denemenin saatlik giriş
 * kaydını geri alır. Kayıt connectToUyap'tan ÖNCE yazıldığı için bu hatalarda elle geri alınır; değerle
 * (yalnız bu denemenin kaydı) silinir, tek uçuş sayesinde araya başka bir kayıt girmez.
 */
function girisHakkiniGeriVer(zaman: number): void {
    const i = botGirisZamanlari.lastIndexOf(zaman);
    if (i >= 0) {
        botGirisZamanlari.splice(i, 1);
    }
}

function otoGirisBeklemesiMs(deneme: number): number {
    const i = Math.min(Math.max(deneme - 1, 0), OTO_GIRIS_BEKLEMELERI_MS.length - 1);
    return OTO_GIRIS_BEKLEMELERI_MS[i];
}

/**
 * UYAP engeli kilidi açık mı: host durumu (pencere yenilemede geri yüklenir) YA DA plugin kilidi. YALNIZ GİRİŞ
 * kapılarında kullanılır; hata sınıflamasında KULLANILMAZ (sınıflama yalnız `uyapEngelHatasiMi(e)`'den: kilit
 * sürerken kullanıcı eylemiyle yapılan yoklamanın gerçek "oturum yok" sonucu da doğru sınıflanır).
 */
function uyapEngelliMi(ctx: ActionContext<AppState, AppState>): boolean {
    return ctx.state.uyapEngeli !== null || uyapEngelKilidiAktifMi();
}

/** Kilit sürerken kullanıcı eylemi sayılan çağrılar: Bağlan/appbar (`kullanici`) ve üç diyalog düğmesi (`force`). */
function kullaniciEylemiMi(payload?: { kullanici?: boolean, force?: boolean }): boolean {
    return payload !== undefined && (payload.kullanici === true || payload.force === true);
}

/**
 * Panele geçici duyuru: mevcut `notification` olayı (kabuk HAM aktarır; ek alan geçer). Yeni panel `uyapEngeli`
 * işaretini görünce çarksız gösterir; eski panel yalnız `message`+`seconds` okur. Hata yutulur (duyuru isteğe bağlı).
 */
function engeliPanelinDuyur(zaman: number): void {
    try {
        app.$socket.client.emit('notification', {
            message: engelPanelMesaji(zaman),
            seconds: UYAP_ENGEL_PANEL_BILDIRIM_SN,
            uyapEngeli: {zaman}
        });
    } catch (e) {
        console.warn('Panel duyurusu yayınlanamadı:', e);
    }
}

/**
 * Kilit VARKEN gelen 'oto' isteğini reddeder (commit YOK): yerel player 'dur' ise panel ve kabuğun kaydı 'dur'a
 * döner; tutarsız 'oto' ise yeniden durdurulur (BEKLENMEZ: olay sırası bugünkü gibi senkron kalır;
 * oyuncuyuDuraklat hatalarını kendi içinde yutar); 'durduruluyor'da hiçbir şey yapılmaz (döngü 'dur' yayınlar).
 * `playerOlayiniIsle`nin 'reddet' kolu VE kaldırma beklenirken yeniden kilit kurulan 'kaldir-uygula' kolu kullanır.
 */
function engelVarkenOtoyuReddet(ctx: ActionContext<AppState, AppState>): void {
    const yerel = Number(ctx.getters.getPlayerDurum);
    if (yerel === PlayerDurum.dur) {
        // Panel ve kabuk kaydı 'dur'a döner.
        app.$socket.client.emit('player', PlayerDurum.dur);
    } else if (yerel === PlayerDurum.oto) {
        oyuncuyuDuraklat(ctx).catch((e: unknown) => console.warn('Oyuncu duraklatılamadı:', e));
    }
}

/**
 * eİcraPro kimliği imzacıya devredildi ve doğrulandı mı: AKTİF KİMLİK var ve token'ı
 * geçersizleşmemiş (eicraproDurumu 'tamam'). Kaçan bir `updateToken` olayı, silinen token ve
 * pencere yenileme kendini düzeltir: aktif kimlik pencere yenilemesinde sessionStorage'dan geri
 * yüklenir (load), ham öneri her sağlık tikinde ve Bağlan'da yeniden değerlendirilir
 * (kimlikOnerisiniIsle). Ayrıntı: utils/eicraproBaglantisi.ts, store/aktifKimlik.ts.
 */
function eicraproBagli(ctx: ActionContext<AppState, AppState>): boolean {
    return ctx.getters.isEicraproBagli === true;
}

// Servis hazırlık yoklaması: sabit uyku yerine yoklayarak bekle.
export const SERVIS_YOKLAMA_ARALIK_MS = 200;
export const SERVIS_YOKLAMA_TAVAN_MS = 6000;

/**
 * yokla() true dönene kadar bekler; tavana ulaşınca yine de devam eder.
 * Servis kalkmadıysa hata fırlatmaz: çağıran akış (load) zaten servis kapalıyken
 * de çalışabiliyor, kullanıcıya durumu ana ekrandaki servis kartı gösteriyor.
 */
async function servisiBekle(yokla: () => Promise<boolean>): Promise<boolean> {
    const bitis = Date.now() + SERVIS_YOKLAMA_TAVAN_MS;
    while (Date.now() < bitis) {
        try {
            if (await yokla()) {
                return true;
            }
        } catch (e) {
            /* yoklama hatası = henüz hazır değil */
        }
        await new Promise((res) => setTimeout(res, SERVIS_YOKLAMA_ARALIK_MS));
    }
    return false;
}

type GirisKapisi =
    | {tamam: true, serial: string}
    | {tamam: false, kapi: 'eicrapro' | 'uyap-engeli' | 'devre-kesici' | 'oturum-limiti' | 'kart-yok' | 'kart-secilmedi'
        | 'kart-tckn-yok' | 'kart-hesaba-ait-degil' | 'pin-kilitli' | 'pin-yok'};

/**
 * Sessiz UYAP girişinin İLK kapıları: eİcraPro kimliği, UYAP engeli, devre kesici, oturum kotası. UYAP'a hiç
 * dokunulmasını engelleyen kapılardır (kimlik yokken, UYAP insan doğrulaması istemişken ya da ban/kota uyarısı
 * açıkken oturum yoklaması da yapılmaz); hiçbiri kart ya da PIN gerektirmez. Geçerse null.
 */
function ortakKapilar(ctx: ActionContext<AppState, AppState>): GirisKapisi | null {
    if (!eicraproBagli(ctx)) {
        return {tamam: false, kapi: 'eicrapro'};
    }
    // UYAP engeli kilidi (DEV-3572): devralma yoklaması DAHİL hiçbir UYAP isteği yok; saatlik giriş hakkı HARCANMAZ.
    if (uyapEngelliMi(ctx)) {
        return {tamam: false, kapi: 'uyap-engeli'};
    }
    if (devreKesiciAcikMi() || ctx.state.devreKesiciUyarisi) {
        return {tamam: false, kapi: 'devre-kesici'};
    }
    // Kota doluyken (5 aktif oturum) her deneme boşuna bir /sign + web1.uyap
    // demek; UYAP yeni oturum vermiyor. Kullanıcı diğer oturumlarını kapatıp
    // dialogdan yeniden denemeli.
    if (ctx.state.oturumLimitiUyarisi) {
        return {tamam: false, kapi: 'oturum-limiti'};
    }
    return null;
}

/**
 * Sessiz UYAP girişinin (otomatik giriş ve bot yeniden bağlanması) kart/PIN kapıları: YENİ e-imza
 * girişi için gerekenler; hiçbiri UYAP'a istek atmaz. Sıra: kart, kartın TCKN'si, hesap-kart eşleşmesi,
 * kayıtlı PIN. Hesap TCKN'si aktif kimlikten (lisans sahibi) gelir; bilinmeyen kart TCKN'si artık
 * ENGELDİR (eskiden eksik veri geçiyordu). Mevcut oturumu DEVRALMAK bu kapılara bağlı değildir
 * (oturumuDevralmayiDene: oturum zaten açık, kart ve PIN gerekmez).
 */
async function kartPinKapilari(ctx: ActionContext<AppState, AppState>): Promise<GirisKapisi> {
    if (!Array.isArray(ctx.state.availableCardList) || ctx.state.availableCardList.length === 0) {
        return {tamam: false, kapi: 'kart-yok'};
    }
    const serial = ctx.state.selectedCardSerial;
    if (!serial) {
        return {tamam: false, kapi: 'kart-secilmedi'};
    }
    // Seçili kart hesaba ait değilse otomatik deneme "İzinsiz İmza" uyarısı
    // üretir ve bu uyarı sessiz modda da gösterilir (güvenlik uyarısı).
    // Kullanıcının istemediği bir modalı arka planda tekrar tekrar açmamak
    // için kimlik burada, giriş denenmeden önce kontrol edilir.
    const secili = ctx.state.availableCardList.find(
        (c: any) => c?.certificate?.certificateId === serial
    );
    const hesapTckn = tcknNormalize(ctx.getters.hesapTckn);
    const kartTckn = tcknNormalize(secili?.certificate?.subjectSerial);
    if (!kartTckn) {
        return {tamam: false, kapi: 'kart-tckn-yok'};
    }
    if (!hesapTckn || hesapTckn !== kartTckn) {
        return {tamam: false, kapi: 'kart-hesaba-ait-degil'};
    }
    // Şifreli PIN deposu açılmadan kayıtlı PIN aranmaz (idempotent; yüklüyse hemen döner):
    // mounted bitmeden gelen updateToken eksik PIN görmesin.
    try {
        await app.$imza.pinDeposunuYukle();
    } catch (e) {
        console.error('PIN deposu yüklenemedi:', e);
    }
    // İmza programı bu kartın PIN'ini kilitli bildirdi: sessizce imza denenmez (kayıtlı PIN zaten
    // silindi); bekleme nedeni "PIN gerekli" değil "kilitli" olur. Plugin'den önce yayına giren host
    // eski plugin'le derlenmez, ama testlerdeki ve eski kopyalardaki $imza bu yöntemi taşımayabilir.
    if (typeof app.$imza.kartPinKilitliMi === 'function' && app.$imza.kartPinKilitliMi(serial)) {
        return {tamam: false, kapi: 'pin-kilitli'};
    }
    if (!app.$imza.kartPinKayitliMi(serial)) {
        return {tamam: false, kapi: 'pin-yok'};
    }
    return {tamam: true, serial};
}

type DevralmaSonucu = 'devralindi' | 'gecersiz' | 'atlandi';

/**
 * Yeni bir tetikleyici (kart takılması, yeni kimlik, tarayıcıdan updateToken) geldi: önceki OLUMSUZ oturum
 * yoklaması hükmünü yitirir, devralma yoklaması yeniden yapılabilir. Son yoklama DEVRALMA_YOKLAMA_ARALIK_MS
 * içinde yapıldıysa sonucu hâlâ tazedir ve hüküm KALKMAZ: tetikleyici o yoklamayla karşılanmış sayılır (kimlik
 * sonrası akış oturumu az önce yokladı; kart takılması ya da token yenilemesi UYAP'ta oturum doğurmaz) ve
 * aynı yoklama arka arkaya yinelenmez. Sağlık tiki ve bot döngüsü tetikleyici DEĞİLDİR.
 */
function devralmaYoklamasiniAc(): void {
    if (Date.now() - sonOturumYoklamasi >= DEVRALMA_YOKLAMA_ARALIK_MS) {
        oturumYoklamasiOlumsuz = false;
    }
}

/** Son oturum yoklaması taze (DEVRALMA_YOKLAMA_ARALIK_MS içinde) ve olumsuz mu: aynı yoklama yinelenmez. */
function oturumYoklamasiTazeOlumsuzMu(): boolean {
    return oturumYoklamasiOlumsuz && Date.now() - sonOturumYoklamasi < DEVRALMA_YOKLAMA_ARALIK_MS;
}

/**
 * Mevcut UYAP oturumunu DEVRALMA denemesi (DEV-2603 inceleme B17). İmzacının "bağlı" bayrağı düşükken
 * (pencere yenilemesi, arayüz güncellemesi) UYAP'ta hâlâ geçerli bir oturum olabilir; devralmak kart,
 * PIN ya da e-imza girişi GEREKTİRMEZ (eskiden her updateToken oturumu kapısız yokluyordu). Bu yüzden
 * kart/PIN kapılarından ÖNCE, eİcraPro kimliği ve devre kesici/kota kapılarından SONRA denenir.
 * Yoklama `uyapOturumuGecerliMi`dir: KullaniciBilgileri + kimlik kapısı (lisans sahibinin TCKN'si ile
 * oturumun TCKN'si eşleşmeli, aksi halde devralınmaz). E-imza ile YENİ giriş kapıların arkasında kalır.
 *
 *  - 'devralindi': oturum geçerliydi, bağlı sayıldı (bekleme bölümü biter);
 *  - 'gecersiz': oturum yok ya da hesaba ait değil (yoklama yapıldı, sonuç olumsuz);
 *  - 'atlandi': yoklanmadı (eski avukatın oturumu 'Geç' sonrası, önceki yoklama olumsuzdu ve tetikleyici
 *    gelmedi, son yoklamadan beri DEVRALMA_YOKLAMA_ARALIK_MS dolmadı, başka yol bağlandı) ya da yoklama
 *    tamamlanamadı.
 * UYAP'a yük: tek uçuş; son yoklama HER yoldan sayılır (uyapOturumuGecerliMi damgalar: giriş denemesi,
 * kurtarma ve kimlik sonrası akış zaten yokladıysa yenisi atılmaz); OLUMSUZ sonuç tetikleyiciye kadar
 * kalıcıdır. Yani kart ya da PIN beklerken bot gece boyunca UYAP'a yoklama yağdırmaz (en çok bir
 * yoklama), yabancı oturum varken "başka hesap" diyaloğu, bildirim ve ses her 2 dakikada yeniden doğmaz.
 */
function oturumuDevralmayiDene(ctx: ActionContext<AppState, AppState>): Promise<DevralmaSonucu> {
    if (devralmaUcusu) {
        return devralmaUcusu;
    }
    if (ctx.state.oturumYenilenmeli || oturumYoklamasiOlumsuz ||
        Date.now() - sonOturumYoklamasi < DEVRALMA_YOKLAMA_ARALIK_MS) {
        return Promise.resolve('atlandi');
    }
    // Yoklama sürerken başka bir yol bağlanmış ya da giriş başlatmış, ya da 'Geç' ile kimlik değişmiş
    // olabilir: doğrulanan oturum artık güncel değildir, o yol bitirir ve oturum yeniden bağlı yapılmaz.
    const durumDegisti = () => ctx.getters.isUyapConnected || ctx.getters.isUyapConnecting || ctx.state.oturumYenilenmeli;
    devralmaUcusu = (async (): Promise<DevralmaSonucu> => {
        try {
            if (!(await ctx.dispatch('uyapOturumuGecerliMi'))) {
                // UYAP'ın engeli "oturum yok" değildir: yoklanamadı sayılır.
                return sonYoklamaEngelliydi ? 'atlandi' : 'gecersiz';
            }
            if (durumDegisti()) {
                return 'atlandi';
            }
            // Oturum yukarıda doğrulandı; meta verideki geçici bir hata geçerli oturumu devralınmaz
            // bırakmamalı (connectToUyap ve fastLoginUyap aynı yolda aynısını yapar). loadUyapMetaData
            // başarısızlıkta avukat bilgisini siler; kimlik kapısı oturumun sahibini oradan okuduğu için
            // doğrulanan bilgi geri konur.
            const dogrulanan = ctx.state.uyapAvukatBilgileri;
            await ctx.dispatch('loadUyapMetaData').catch((e) => {
                console.error('UYAP meta verisi yüklenemedi:', e);
                if (!ctx.state.uyapAvukatBilgileri && dogrulanan) {
                    ctx.commit('setUyapAvukatBilgileri', dogrulanan);
                }
            });
            if (durumDegisti()) {
                return 'atlandi';
            }
            ctx.commit('setUyapConnection', true);
            devreKesiciSifirla();
            ctx.dispatch('kimlikUyusmazligiGiderildi');
            return 'devralindi';
        } catch (e) {
            console.warn('UYAP oturumu devralınamadı:', e);
            return 'atlandi';
        } finally {
            devralmaUcusu = null;
        }
    })();
    return devralmaUcusu;
}

/**
 * Sessiz giriş: 'otomatik' (kart takılma, sağlık tiki, updateToken; en çok OTO_GIRIS_MAX_DENEME
 * ardışık başarısızlık sonra susar) ve 'bot' (dongu bağlantı düşünce çağırır; ASLA vazgeçmez ama
 * saatte en çok BOT_SAATLIK_GIRIS_SINIRI deneme). İki mod AYNI sayaçları ve geri çekilmeyi paylaşır:
 * sağlık tikindeki otomatik giriş ile bot döngüsü birbirini çift saymaz, çift giriş yapmaz.
 * Sıra: ortak kapılar (eİcraPro kimliği, devre kesici, kota), mevcut oturumu DEVRALMA (kart ve PIN
 * gerekmez; hız sınırlı yoklama, oturumuDevralmayiDene), kart/PIN kapıları, geri çekilme ve saatlik
 * sınır, e-imza ile giriş. Kapılar geçmezse e-imza girişi DENENMEZ; UYAP'a gidebilecek tek istek devralma
 * yoklamasıdır (olumsuz sonuç tetikleyiciye kadar kalıcıdır, susmuş otomatik girişte hiç yok). Bot modunda
 * insan gerektiren engel bekleme nedeni olur. Kodlu (insan gerektiren) giriş hatası başarısızlık sayılmaz:
 * sayaç artmaz, saatlik giriş hakkı harcanmaz (kayıt geri alınır), yalnız ilk geri çekilme adımı
 * kadar beklenir.
 */
async function sessizGirisDene(
    ctx: ActionContext<AppState, AppState>,
    mod: 'otomatik' | 'bot'
): Promise<void> {
    if (ctx.getters.isUyapConnected) {
        if (mod === 'bot' && ctx.state.botBeklemeSebebi !== null) {
            ctx.commit('setBotBeklemeSebebi', null);
            ctx.commit('setBotSonrakiDeneme', null);
        }
        return;
    }
    // Süren bir girişe katılınmaz: o denemenin başarısızlığı her çağıranda
    // ayrı sayılır ve geri çekilme iki katına çıkardı (eİcraPro açılışta
    // updateToken'ı art arda iki kez gönderebiliyor).
    if (ctx.getters.isUyapConnecting) {
        return;
    }
    let kapi: GirisKapisi | null = ortakKapilar(ctx);
    // Oturum az önce (bu çağrıda ya da başka yoldan) yoklandı ve yok: connectToUyap aynı yoklamayı yinelemez.
    let oturumYoklandi = false;
    if (kapi === null) {
        // Susmuş otomatik giriş (OTO_GIRIS_MAX_DENEME ardışık başarısızlık) UYAP'a hiç dokunmaz.
        if (!(mod === 'otomatik' && otoGirisBasarisizSayisi >= OTO_GIRIS_MAX_DENEME)) {
            await oturumuDevralmayiDene(ctx);
            // Devralındıysa (ya da başka yol bağlandı/giriş başlattıysa) yapılacak bir şey kalmadı.
            if (ctx.getters.isUyapConnected || ctx.getters.isUyapConnecting) {
                return;
            }
            // Devralma yoklaması UYAP'ın engeline çarptıysa (kilit az önce kuruldu) e-imza girişine GEÇİLMEZ.
            if (uyapEngelliMi(ctx)) {
                return;
            }
            oturumYoklandi = oturumYoklamasiTazeOlumsuzMu();
        }
        kapi = await kartPinKapilari(ctx);
    }
    if (!kapi.tamam) {
        if (mod === 'otomatik') {
            switch (kapi.kapi) {
                case 'eicrapro':
                    console.log('eİcraPro bağlantısı bekleniyor, otomatik UYAP girişi yapılmıyor.');
                    break;
                case 'uyap-engeli':
                    // 30 sn'de bir sağlık tiki: warn değil log.
                    console.log('UYAP engeli kilidi açık, otomatik giriş denenmiyor.');
                    break;
                case 'devre-kesici':
                    console.warn('Devre kesici açık, otomatik giriş denenmiyor.');
                    break;
                case 'oturum-limiti':
                    console.warn('UYAP oturum kotası dolu, otomatik giriş denenmiyor.');
                    break;
                case 'kart-yok':
                case 'kart-secilmedi':
                    console.log('Kart seçimi belirsiz, otomatik giriş yapılmıyor.');
                    break;
                case 'kart-tckn-yok':
                    console.warn('Kartın TC kimlik numarası okunamadı, otomatik giriş yapılmıyor.');
                    break;
                case 'kart-hesaba-ait-degil':
                    console.warn('Takılı kart hesaba ait değil, otomatik giriş yapılmıyor.');
                    // Sessiz çıkmak yetmiyordu: kullanıcı neden bağlanmadığını bilmiyor,
                    // ekran yalnızca "Bağlı Değil" gösteriyordu.
                    ctx.commit('setUyapStatusMessage', {
                        type: 'error',
                        text: 'Takılı e-imza kartı bu hesaba ait değil. Kendi hesabınızla ' +
                              'giriş yapın veya size ait e-imza kartını takın.',
                        timestamp: Date.now()
                    });
                    break;
                case 'pin-kilitli':
                    console.warn('Kartın PIN kodu kilitli, otomatik giriş yapılmıyor.');
                    break;
                case 'pin-yok':
                    console.log('Kart PIN kodu kayıtlı değil, otomatik giriş yapılmıyor.');
                    break;
            }
            return;
        }
        // Bot modu: insan gerektiren engeller bekleme nedeni; diğerleri (kimlik, devre kesici,
        // kota) kendi uyarı yüzeyine sahip, sessiz döner.
        switch (kapi.kapi) {
            case 'kart-yok':
                botBeklemeyiAyarla(ctx, ctx.state.imzaProgramiKapali ? 'IMZA_PROGRAMI_KAPALI' : 'KART_YOK');
                break;
            // Kart seçilmemiş ya da başka avukata ait: e-imza girişi denenmez, player 'oto' KALIR.
            case 'kart-secilmedi':
            case 'kart-hesaba-ait-degil':
                botBeklemeyiAyarla(ctx, 'KART_YOK');
                break;
            case 'kart-tckn-yok':
                botBeklemeyiAyarla(ctx, 'TCKN_EKSIK');
                break;
            case 'pin-kilitli':
                botBeklemeyiAyarla(ctx, 'PIN_KILITLI');
                break;
            case 'pin-yok':
                botBeklemeyiAyarla(ctx, 'PIN_GEREKLI');
                break;
            // UYAP engeli bekleme nedeni DEĞİLDİR (kendi uyarı yüzeyi var: diyalog, kart rozeti, liste bandı).
            case 'uyap-engeli':
                break;
            default:
                break;
        }
        return;
    }
    // Kapılar beklerken (PIN deposu) başka bir giriş başlamış ya da bağlantı kurulmuş olabilir.
    if (ctx.getters.isUyapConnected || ctx.getters.isUyapConnecting) {
        return;
    }
    // Kapılar beklerken UYAP engeli doğmuş olabilir: saatlik giriş hakkı harcanmadan ÖNCE.
    if (uyapEngelliMi(ctx)) {
        return;
    }
    if (mod === 'otomatik' && otoGirisBasarisizSayisi >= OTO_GIRIS_MAX_DENEME) {
        console.warn('Otomatik giriş üst üste başarısız oldu, susuluyor. Kartı çıkarıp takın veya "Bağlan"a basın.');
        return;
    }
    const simdi = Date.now();
    const izin = botGirisiIzinVerilirMi(simdi, botGirisZamanlari, otoGirisSonrakiDenemeZamani);
    if (!izin.izin) {
        if (mod === 'bot') {
            ctx.commit('setBotSonrakiDeneme', simdi + izin.bekleMs);
            if (izin.sebep === 'saatlik-sinir') {
                botBeklemeyiAyarla(ctx, 'UYAP_ERISILEMIYOR');
            }
        }
        return;
    }
    botGirisZamanlari = botGirisZamanlari.filter((zaman) => simdi - zaman < 3600000);
    botGirisZamanlari.push(simdi);
    try {
        await ctx.dispatch('connectToUyap', {sessiz: true, oturumYoklandi});
        otoGirisBasarisizSayisi = 0;
        otoGirisSonrakiDenemeZamani = 0;
        if (mod === 'bot') {
            ctx.commit('setBotBeklemeSebebi', null);
            ctx.commit('setBotSonrakiDeneme', null);
        }
    } catch (e) {
        // eİcraPro kimliği araya girip kesildiyse bu başarısız giriş değil, bekleme: sayaç artmaz ve
        // saatlik giriş hakkı harcanmaz.
        if (eicraproBekleniyorHatasiMi(e)) {
            girisHakkiniGeriVer(simdi);
            return;
        }
        // UYAP engeli başarısız giriş DEĞİLDİR: sayaç artmaz, saatlik giriş hakkı harcanmaz.
        if (uyapEngelHatasiMi(e)) {
            girisHakkiniGeriVer(simdi);
            return;
        }
        const sebep = kodtanSebebe((e as any)?.kod);
        if (sebep !== null) {
            // İnsan gerektiriyor (PIN yok, kart yok...): sayaç ARTMAZ ve saatlik giriş hakkı HARCANMAZ
            // (kayıt geri alınır). Geri alınmasaydı 5 sn'lik döngü ~30 sn'de 6 deneme yapıp botu bir
            // saat kilitlerdi (program bir dakika sonra açılsa bile). Durum değişmeden aynı denemeyi
            // 5 sn'de bir yinelememek (her biri UYAP'a yoklama demek) için ilk geri çekilme adımı kadar
            // beklenir; kart takılması (kartGecisi) ve yeni kimlik bu beklemeyi sıfırlar.
            girisHakkiniGeriVer(simdi);
            otoGirisSonrakiDenemeZamani = Date.now() + OTO_GIRIS_BEKLEMELERI_MS[0];
            // İmza programının kendi mesajı (ör. bilinmeyen imza hatası) kaybolmasın.
            console.warn(`Sessiz giriş yapılamadı (${sebep}): ${(e as any)?.message ?? ''}`);
            if (mod === 'bot') {
                botBeklemeyiAyarla(ctx, sebep);
                ctx.commit('setBotSonrakiDeneme', otoGirisSonrakiDenemeZamani);
            } else {
                console.log(`Otomatik giriş yapılamadı (${sebep}).`);
            }
            return;
        }
        otoGirisBasarisizSayisi++;
        const bekleme = otoGirisBeklemesiMs(otoGirisBasarisizSayisi);
        otoGirisSonrakiDenemeZamani = Date.now() + bekleme;
        if (mod === 'bot') {
            ctx.commit('setBotSonrakiDeneme', otoGirisSonrakiDenemeZamani);
            if (otoGirisBasarisizSayisi >= 3) {
                botBeklemeyiAyarla(ctx, 'UYAP_ERISILEMIYOR');
            }
        }
        console.error(`${mod === 'bot' ? 'Bot girişi' : 'Otomatik giriş'} başarısız (${otoGirisBasarisizSayisi}/${OTO_GIRIS_MAX_DENEME}), ${bekleme / 1000} sn sonra tekrar denenebilir.`, e);
    }
}

/**
 * Açılmış/devralınmış UYAP oturumu AKTİF hesaba (lisans sahibinin TCKN'si) ve seçili karta
 * ait mi (uyapOturumuGecerliMi ve connectToUyap'ın giriş sonrası son kontrolü ortak kullanır).
 * Sorun yoksa null, varsa çağıranın fırlatabileceği (kodlu) Error döner.
 *
 *  - KullaniciBilgileri cevabında tcKimlikNo yoksa oturum DOĞRULANAMADI sayılır: diyalog açılmaz,
 *    durum kartına hata yazılır.
 *  - 'kart' alanı YALNIZ kart seçiliyse verilir. Sıkı modda kart anahtarı verilip boşsa
 *    "bilinmeyen kart = uyuşmazlık" işler; kart takılı değilken geçerli bir UYAP oturumunu
 *    devralmak ise reddedilmez.
 *  - bilinmiyor=true (hesap/kart TCKN'si bilinmiyor): çatışma değil EKSİKLİKTİR; engelleyici
 *    "başka hesabın oturumu" diyaloğu açılmaz, bot durdurulmaz, yalnız mesaj yazılır.
 *  - 'hesap' çatışması güvenlik olayıdır: engelleyici uyarı. 'kart' çatışması düzeltilebilir
 *    (doğru kartla yeniden giriş) ve diyalog açmaz.
 */
function oturumKimliginiDenetle(
    ctx: ActionContext<AppState, AppState>,
    avukat: KullaniciBilgileriCevap | undefined
): Error | null {
    if (!tcknNormalize(avukat?.tcKimlikNo)) {
        console.warn('UYAP oturumunun TC kimlik numarası okunamadı, oturum doğrulanamadı.');
        const mesaj = 'UYAP oturumunun TC kimlik numarası doğrulanamadı.';
        ctx.commit('setUyapStatusMessage', {type: 'error', text: mesaj, timestamp: Date.now()});
        return new Error(mesaj);
    }
    const secili = ctx.state.selectedCardSerial
        ? ctx.state.availableCardList?.find(
            (c: any) => c?.certificate?.certificateId === ctx.state.selectedCardSerial
        )
        : undefined;
    const girdi: { oturum: any, hesap: any, kart?: any } = {
        oturum: avukat?.tcKimlikNo,
        hesap: ctx.getters.hesapTckn
    };
    if (secili) {
        girdi.kart = secili?.certificate?.subjectSerial;
    }
    const denetim = oturumKimligiUyusuyor(girdi);
    if (denetim.uyusuyor) {
        return null;
    }
    if (denetim.bilinmiyor) {
        const kartBilinmiyor = denetim.sebep === 'kart';
        const mesaj = kartBilinmiyor
            ? 'Takılı e-imza kartının TC kimlik numarası okunamadı. Kartınızı kontrol edin.'
            : HESAP_TCKN_BILINMIYOR_MESAJI;
        ctx.commit('setUyapStatusMessage', {type: 'error', text: mesaj, timestamp: Date.now()});
        if (kartBilinmiyor) {
            // İnsan gerektiren engel: bot bekleme nedeni TCKN_EKSIK olur.
            return Object.assign(new Error(mesaj), {kod: 'TCKN_EKSIK'});
        }
        return kimlikHatasi(mesaj, 'HESAP_TCKN_BILINMIYOR');
    }
    console.warn(`Oturum farklı bir ${denetim.sebep === 'hesap' ? 'hesaba' : 'karta'} ait.`);
    // Oturum BAŞKA BİR HESABA aitse yeniden giriş çözüm değil, güvenlik
    // olayıdır: kullanıcı hesabını başkasına verip onun e-imzasıyla açılan
    // oturum üzerinden işlem yaptırabilir. Engelleyici uyarı gösterilir.
    // Kart uyuşmazlığı ise düzeltilebilir bir durum (doğru kartla yeniden giriş).
    if (denetim.sebep === 'hesap') {
        ctx.dispatch('kimlikUyusmazligiUyarisiGoster', {sebep: 'hesap'});
    }
    return kimlikHatasi(KIMLIK_UYUSMAZLIGI_MESAJI, 'KIMLIK_UYUSMAZLIGI');
}

/**
 * Tarayıcı kaynaklı kurtarma isteğinde ('kurtarma') "bağlı" bayrağına güvenmeden UYAP oturumunu
 * CANLI doğrular (uyapOturumuGecerliMi: yoklama + kimlik denetimi). Tek uçuş: eşzamanlı istekler aynı
 * yoklamayı paylaşır. Geçerli çıkan sonuç KURTARMA_DOGRULAMA_ARALIK_MS boyunca yeniden yoklanmaz;
 * geçersiz sonuç önbelleğe alınmaz (çağıran bayrağı düşürür, sonraki istekler bu yola girmez).
 * Yoklama beklenmedik biçimde fırlatırsa oturum doğrulanamadı sayılır (geçersiz).
 */
function kurtarmaOturumuGecerliMi(ctx: ActionContext<AppState, AppState>): Promise<boolean> {
    if (sonGecerliKurtarmaDogrulamasi !== null &&
        Date.now() - sonGecerliKurtarmaDogrulamasi < KURTARMA_DOGRULAMA_ARALIK_MS) {
        return Promise.resolve(true);
    }
    if (!kurtarmaDogrulamaUcusu) {
        kurtarmaDogrulamaUcusu = (async () => {
            try {
                const gecerli = (await ctx.dispatch('uyapOturumuGecerliMi')) === true;
                sonGecerliKurtarmaDogrulamasi = gecerli ? Date.now() : null;
                return gecerli;
            } catch (e) {
                console.error('Kurtarma isteğinde UYAP oturumu doğrulanamadı:', e);
                sonGecerliKurtarmaDogrulamasi = null;
                return false;
            } finally {
                kurtarmaDogrulamaUcusu = null;
            }
        })();
    }
    return kurtarmaDogrulamaUcusu;
}

export const store = new Vuex.Store<AppState>({
    modules: {
        // @ts-ignore
        gorevYoneticisi
    },
    state: {
        uyapConnection: false,
        appStatus: AppStatus.loading,
        manifestResponse: {files: []},
        availableCardList: [],
        selectedCardSerial: null,
        devMode: true,
        eicraproDevMode: false,  // Mock data kullanmak için true yap
        uyapAvukatBilgileri: undefined,
        uyapAvukatBakiye: undefined,
        uyapSorguBakiye: undefined,
        uyapStatusMessage: null,
        connectionHealthCheckInterval: null as number | null,
        healthCheckRetryCount: 0,
        healthCheckMaxRetries: 3,
        // Health check ile durum kartının paylaştığı son yoklama sonucu.
        sonImzaProbe: null as { basarili: boolean, zaman: number } | null,
        // UYAP 5 oturum sınırına takıldığında gösterilen uyarı (null = kapalı).
        oturumLimitiUyarisi: null as { zaman: number } | null,
        // 401 devre kesici açıldığında gösterilen uyarı (null = kapalı).
        devreKesiciUyarisi: null as { zaman: number } | null,
        // Giriş aşaması; null = giriş yapılmıyor.
        uyapGirisAsamasi: null as UyapGirisAsamasi | null,
        // Açık UYAP oturumu hesaba ait değil ya da sunucu 423 verdi (null = sorun yok).
        kimlikUyusmazligiUyarisi: null as { zaman: number, sebep: KimlikUyusmazligiSebebi, mesaj?: string } | null,
        // Aktif kimlik, öneri/bekleyen geçiş, token geçersizliği, oturum yenileme (store/aktifKimlik.ts).
        ...aktifKimlikState(),
        // Botun insan gerektiren bekleme nedeni ve sonraki giriş denemesi (DEV-3898).
        botBeklemeSebebi: null as BotBeklemeSebebi | null,
        botSonrakiDeneme: null as number | null,
        // Son kart sorgusunda e-İmza programı yanıt vermedi (bekleme nedeni KART_YOK / IMZA_PROGRAMI_KAPALI ayrımı).
        imzaProgramiKapali: false,
        // Kimlik uyuşmazlığı botu duraklattıysa önceki player durumu (doğrulanınca otomatik devam).
        kimlikDuraklatmasi: null as { oncekiPlayer: PlayerDurum, zaman: number } | null,
        // UYAP insan doğrulaması (engel) uyarısı (DEV-3572). STORE OLUŞURKEN sessionStorage'dan geri yüklenir
        // (load()'da DEĞİL: açılış yarışı): pencere yenilemede kilit sürer, imzacı kapatılıp açılınca kayıt yoktur (K4).
        uyapEngeli: uyapEngeliniOku(oturumDeposu())
    },
    getters: {
        appStatus: (state) => state.appStatus,
        isLoading: (state) => state.appStatus === AppStatus.loading,
        isUpdate: (state) => state.appStatus === AppStatus.update,
        isBrowser: (state) => state.appStatus === AppStatus.browser,
        isElectron: (state) => state.appStatus === AppStatus.electron,
        isUyapConnected: (state) => state.uyapConnection,
        // Aktif kimlik getter'ları: aktifKimlik, aktifTenantId, hesapTckn, eicraproDurumu,
        // eicraproDurumMesaji, tenantBilgileri, kimlikSeridi, botKimligiYuku, botBeklemeBilgisi ve
        // iki adlı bayrak isTokenExis / isEicraproBagli (tek kaynak eicraproDurumu). Ortak plugin'in
        // bot döngüsü isEicraproBagli'yi okur (GorevYoneticisi.ts taskInterval); icrapro-app'te
        // tanımsızdır ve orada kapı açık sayılır.
        ...aktifKimlikGetters,
        botBeklemeSebebi: (state) => state.botBeklemeSebebi,
        botSonrakiDeneme: (state) => state.botSonrakiDeneme,
        imzaProgramiKapali: (state) => state.imzaProgramiKapali,
        oturumYenilenmeli: (state) => state.oturumYenilenmeli,
        isDevMode: (state) => state.devMode,
        isEicraproDevMode: (state) => state.eicraproDevMode,
        uyapAvukatBilgileri: (state) => state.uyapAvukatBilgileri,
        uyapAvukatBakiye: (state) => state.uyapAvukatBakiye,
        uyapSorguBakiye: (state) => state.uyapSorguBakiye,
        availableCardList: (state) => state.availableCardList,
        selectedCardSerial: (state) => state.selectedCardSerial,
        uyapStatusMessage: (state) => state.uyapStatusMessage,
        healthCheckRetryCount: (state) => state.healthCheckRetryCount,
        isHealthChecking: (state) => state.connectionHealthCheckInterval !== null,
        sonImzaProbe: (state) => state.sonImzaProbe,
        oturumLimitiUyarisi: (state) => state.oturumLimitiUyarisi,
        devreKesiciUyarisi: (state) => state.devreKesiciUyarisi,
        uyapGirisAsamasi: (state) => state.uyapGirisAsamasi,
        isUyapConnecting: (state) => state.uyapGirisAsamasi !== null,
        kimlikUyusmazligiUyarisi: (state) => state.kimlikUyusmazligiUyarisi,
        uyapEngeli: (state) => state.uyapEngeli,
        // Yalnız arayüz/host içindir: plugin KENDİ kilidini kendi işleviyle okur, bu getter'a bağlı DEĞİLDİR.
        uyapEngeliKilitli: (state) => state.uyapEngeli !== null
    },
    mutations: {
        setAppState(state: AppState, value: AppStatus): void {
            state.appStatus = value;
        },
        setManifestResponse(state: AppState, response: ManifestResponse) {
            state.manifestResponse = response;
        },
        setAvailableCardList(state: AppState, value: any) {
            state.availableCardList = value;
        },
        setSelectedCardSerial(state: AppState, serial: string | null) {
            state.selectedCardSerial = serial;
        },
        setUyapConnection(state: AppState, payload: boolean) {
            app.$socket.client.emit("uyapconnection", {
                connected: payload,
                JSESSIONID: payload ? sessionStorage.getItem('JSESSIONID') : ''
            });
            state.uyapConnection = payload;
            // Bağlantı kuruldu: bekleme bölümü biter (bağlı yollarının hepsini tek noktada kapsar).
            // false commit'lerde (düşme, uyuşmazlık) bekleme sebebine dokunulmaz.
            if (payload) {
                state.botBeklemeSebebi = null;
                state.botSonrakiDeneme = null;
            }
        },
        setUyapAvukatBilgileri(state: AppState, avukat: KullaniciBilgileriCevap | undefined) {
            state.uyapAvukatBilgileri = avukat;
        },
        setUyapAvukatBakiye(state: AppState, payload: string | undefined) {
            state.uyapAvukatBakiye = payload;
        },
        setUyapSorguBakiye(state: AppState, payload: string | undefined) {
            state.uyapSorguBakiye = payload;
        },
        setUyapStatusMessage(state: AppState, payload: UyapStatusMessage | null) {
            state.uyapStatusMessage = payload;
        },
        setHealthCheckInterval(state: AppState, interval: any) {
            state.connectionHealthCheckInterval = interval;
        },
        setHealthCheckRetryCount(state: AppState, count: number) {
            state.healthCheckRetryCount = count;
        },
        setSonImzaProbe(state: AppState, payload: { basarili: boolean, zaman: number }) {
            state.sonImzaProbe = payload;
        },
        setOturumLimitiUyarisi(state: AppState, payload: { zaman: number } | null) {
            state.oturumLimitiUyarisi = payload;
        },
        setDevreKesiciUyarisi(state: AppState, payload: { zaman: number } | null) {
            state.devreKesiciUyarisi = payload;
        },
        setUyapGirisAsamasi(state: AppState, payload: UyapGirisAsamasi | null) {
            state.uyapGirisAsamasi = payload;
        },
        setKimlikUyusmazligiUyarisi(
            state: AppState,
            payload: { zaman: number, sebep: KimlikUyusmazligiSebebi, mesaj?: string } | null
        ) {
            state.kimlikUyusmazligiUyarisi = payload;
        },
        setKimlikDuraklatmasi(state: AppState, payload: { oncekiPlayer: PlayerDurum, zaman: number } | null) {
            state.kimlikDuraklatmasi = payload;
        },
        setUyapEngeli(state: AppState, payload: UyapEngeli | null) {
            state.uyapEngeli = payload;
        },
        // Kilit yoksa no-op.
        setUyapEngeliDiyalogu(state: AppState, acik: boolean) {
            if (state.uyapEngeli !== null) {
                state.uyapEngeli.diyalogAcik = acik;
            }
        },
        setBotBeklemeSebebi(state: AppState, sebep: BotBeklemeSebebi | null) {
            state.botBeklemeSebebi = sebep;
        },
        setBotSonrakiDeneme(state: AppState, zaman: number | null) {
            state.botSonrakiDeneme = zaman;
        },
        setImzaProgramiKapali(state: AppState, kapali: boolean) {
            state.imzaProgramiKapali = kapali;
        },
        // aktifKimligiAyarla, aktifKimligiGeriYukle, setKimlikTokenGecersiz, setBekleyenKimlik,
        // setKimlikReddi, setKimlikOneriParmakIzi, setKimlikSorgusuHatasi, setGecisDurumu,
        // setOturumYenilenmeli (store/aktifKimlik.ts). "Bağlı" bayrağı state'te tutulmaz, aktif
        // kimlikten türetilir (eicraproDurumu getter'ı).
        ...aktifKimlikMutations
    },
    actions: {
        /**
         * UYAP'a bağlan.
         *
         * @param payload.force  true ise mevcut oturum geçerli olsa bile yeniden giriş
         *                       yapılır. Kullanıcının açık talebi (Bağlan düğmesi) ve
         *                       kart değişimi için gerekli — aksi halde eski kartın
         *                       oturumu geçerli bulunup yanlış avukatla devam edilir.
         * @param payload.oturumYoklandi  true ise çağıran (sessizGirisDene) oturumu AZ ÖNCE yokladı ve
         *                       devralınacak geçerli oturum yok: aynı yoklama yinelenmez, doğrudan
         *                       e-imza girişine geçilir.
         * @param payload.kullanici  true ise çağıran kullanıcının kendi eylemidir (Bağlan kartı, appbar).
         *                       UYAP engeli kilidi AÇIKKEN yalnız `kullanici` ya da `force` (üç diyalog düğmesi)
         *                       geçer; bot, kart takılması, sağlık tiki, socket 'connectToUyap' ve panel
         *                       kurtarması `uyapEngelKapisiHatasi()` ile reddedilir (UYAP'a hiç gidilmez).
         */
        async connectToUyap(
            ctx: ActionContext<AppState, AppState>,
            payload?: { force?: boolean, sessiz?: boolean, oturumYoklandi?: boolean, kullanici?: boolean }
        ) {
            // eİcraPro ile bağlantı sağlanmadan UYAP'a GİRİLMEZ (DEV-2603): hesap
            // TCKN'si henüz bilinmediği için kimlik denetimi atlanır, oturum kime ait
            // olduğu bilinmeden açılır. Bütün giriş yolları (kart takılma, sağlık tiki,
            // Bağlan düğmesi, dialog'lar, socket connectToUyap, bot döngüsünün yeniden
            // bağlanması) bu huniden geçer. Kilidin önünde ve ona dokunmadan: süren bir
            // denemeyi bozmaz. Kimlik gelince giriş updateToken'da yeniden denenir.
            if (!eicraproBagli(ctx)) {
                // Kullanıcı tıklaması (sessiz değil): kaçan bir updateToken burada düzelir,
                // ham öneri yeniden değerlendirilir. Sessiz yollar (bot, kart takılma) beklemez.
                if (payload?.sessiz !== true) {
                    await ctx.dispatch('kimlikOnerisiniIsle', {neden: 'baglan'}).catch(() => undefined);
                }
                if (!eicraproBagli(ctx)) {
                    // 'yok' için eski bekleme metni; 'tckn-eksik' için TCKN eksik / lisans yok metni.
                    throw new Error(ctx.getters.eicraproDurumMesaji);
                }
            }
            // UYAP engeli (DEV-3572): kilit açıkken kullanıcı eylemi DIŞINDAKİ girişler UYAP'a hiç gitmez.
            // Bayrağa ve durum satırına dokunulmaz (bayrak false → panel kurtarma isteği → yeni giriş olurdu).
            if (uyapEngelliMi(ctx) && !kullaniciEylemiMi(payload)) {
                throw uyapEngelKapisiHatasi();
            }
            if (connectToUyapPromise) {
                return connectToUyapPromise;
            }
            connectToUyapPromise = (async () => {
                // Aşama bilgisi durum kartındaki "Bağlanıyor" ekranını sürüyor.
                // İmzalama adımı tek başına ~5 sn; aşama yayınlanmazsa kullanıcı
                // ekranın donduğunu sanıyor ve tekrar tıklıyor.
                ctx.commit('setUyapGirisAsamasi', 'oturum-kontrol');
                try{
                    // Her betaLogin UYAP'ta YENİ oturum açar ama eskisini kapatmaz
                    // (clearCookies yalnızca yerel cookie'yi siler, UYAP'ta logout ucu yok).
                    // 5 oturum kotası dolunca PRTL_GNL_100026-1 gelir. Bu yüzden oturum
                    // hâlâ geçerliyse giriş yapılmaz. KullaniciBilgileri önbelleklenmiyor
                    // (cache active:false), yani bu gerçek bir oturum testidir.
                    // Kimlik değişimi ('Geç') sonrası eski avukatın oturumu devralınmaz: zorla giriş.
                    const force = payload?.force === true || ctx.state.oturumYenilenmeli;
                    let yoklandi = false;
                    if (!force && payload?.oturumYoklandi !== true) {
                        yoklandi = true;
                        if (await ctx.dispatch('uyapOturumuGecerliMi')) {
                            ctx.commit('setUyapConnection', true);
                            devreKesiciSifirla();
                            ctx.commit('setUyapGirisAsamasi', 'bilgiler');
                            await ctx.dispatch('loadUyapMetaData').catch((e) => {
                                // Kilit altında reddedilen bakiye/kullanıcı sorgusu beklenen durumdur (loadUyapMetaData).
                                if (!uyapEngelHatasiMi(e)) {
                                    console.error('UYAP meta verisi yüklenemedi:', e);
                                }
                            });
                            ctx.dispatch('kimlikUyusmazligiGiderildi');
                            return;
                        }
                    }
                    // Yoklama UYAP'ın insan doğrulaması uyarısına çarptıysa "oturum yok" DEĞİLDİR: YENİ e-imza
                    // girişi (betaLogin; UYAP'ta yeni oturum, kota 5) AÇILMAZ.
                    if (yoklandi && sonYoklamaEngelliydi) {
                        throw uyapEngelKapisiHatasi();
                    }
                    ctx.commit('setUyapGirisAsamasi', 'imza');
                    await app.$imza.betaLogin(payload?.sessiz === true);
                    ctx.commit('setUyapGirisAsamasi', 'bilgiler');
                    await ctx.dispatch('loadUyapMetaData');
                    // Giriş sonrası SON KONTROL: açılan oturum bu hesaba (lisans TCKN'si) ve seçili karta
                    // ait mi. Uyuşmazlıkta bağlı sayılmaz (engelleyici diyalog denetimin içinde açılır).
                    const denetimHatasi = oturumKimliginiDenetle(ctx, ctx.state.uyapAvukatBilgileri);
                    if (denetimHatasi !== null) {
                        throw denetimHatasi;
                    }
                    ctx.commit('setUyapConnection', true);
                    ctx.commit('setOturumYenilenmeli', false);
                    // Oturum gerçekten açıldı: 401 serisi bitti, kesici kapanır.
                    // Aksi halde kesici bir kez açıldığında kullanıcı elle bağlansa
                    // bile otomatik giriş kalıcı olarak susuyordu (devreKesiciSifirla
                    // yalnızca bot kurtarması ve dialogdaki "Yeniden Başlat" yolunda
                    // çağrılıyor; dialogu kapatıp elle bağlanan kullanıcı o yollara girmiyor).
                    devreKesiciSifirla();
                    ctx.commit('setUyapStatusMessage', {
                        type: 'success',
                        text: 'Uyap bağlantısı tamamlandı.',
                        timestamp: Date.now()
                    });
                    //app.$toast.success('Uyap bağlantısı tamamlandı.');
                    ctx.dispatch('kimlikUyusmazligiGiderildi');
                }catch (error) {
                    // UYAP engeli: bağlı bayrağına ve durum satırına DOKUNULMAZ (UYAP metni durum satırına sızmaz).
                    if (uyapEngelHatasiMi(error)) {
                        throw error;
                    }
                    ctx.commit('setUyapConnection', false);
                    const errMsg = (error as any)?.message ?? String(error);
                    const message = `Uyap bağlantısı yapılamadı. (${errMsg})`;
                    // Sessiz girişte insan gerektiren engel (PIN yok, kart yok, program kapalı...)
                    // hata değil bekleme nedenidir: durum kartı bekleme metnini gösterir.
                    if (!(payload?.sessiz === true && kodtanSebebe((error as any)?.kod) !== null)) {
                        ctx.commit('setUyapStatusMessage', {
                            type: 'error',
                            text: message,
                            timestamp: Date.now()
                        });
                    }
                    // Hata kodu (ör. PIN_GEREKLI) çağırana ulaşsın: Error olmayan nesne sarmalanırken kaybolmasın.
                    const hata: any = error instanceof Error ? error : new Error(errMsg);
                    if (hata.kod === undefined && (error as any)?.kod !== undefined) {
                        hata.kod = (error as any).kod;
                    }
                    throw hata;
                } finally {
                    ctx.commit('setUyapGirisAsamasi', null);
                    connectToUyapPromise = null;
                }
            })();
            return connectToUyapPromise;
        },
        /**
         * UYAP 5 oturum sınırı uyarısı. Dialog + işletim sistemi bildirimi + ses.
         * Ses yalnızca burada çalar; her uyarıda çalarsa sinyal değerini yitirir.
         */
        oturumLimitiUyarisiGoster(ctx: ActionContext<AppState, AppState>) {
            // Uyarı zaten açıksa tekrar bildirim/ses üretme.
            if (ctx.state.oturumLimitiUyarisi) {
                return;
            }
            ctx.commit('setOturumLimitiUyarisi', {zaman: Date.now()});
            ctx.commit('setUyapStatusMessage', {
                type: 'error',
                text: 'UYAP oturum sınırına ulaşıldı. Açık UYAP oturumlarınızı kapatıp yeniden bağlanın.',
                timestamp: Date.now()
            });
            isletimSistemiBildirimi(
                'UYAP oturum sınırına ulaşıldı',
                'Açık UYAP oturumlarınızı kapatıp yeniden bağlanın.'
            );
            uyariSesi();
        },
        oturumLimitiUyarisiniKapat(ctx: ActionContext<AppState, AppState>) {
            ctx.commit('setOturumLimitiUyarisi', null);
        },
        /**
         * 401 devre kesici açıldı: kısa sürede çok sayıda oturum hatası alındı ve
         * denemeye devam etmek ban riski taşıyor. Bot durdurulur, kullanıcıya
         * dialog + bildirim + ses verilir. Kesici yalnızca kullanıcı bilinçli
         * olarak yeniden başlattığında sıfırlanır.
         */
        devreKesiciUyarisiGoster(ctx: ActionContext<AppState, AppState>) {
            if (ctx.state.devreKesiciUyarisi) {
                return;
            }
            ctx.commit('setPlayerDurum', PlayerDurum.dur);
            ctx.commit('setDevreKesiciUyarisi', {zaman: Date.now()});
            ctx.commit('setUyapStatusMessage', {
                type: 'error',
                text: 'UYAP bağlantısında tekrarlayan hata; ban riskine karşı işlemler durduruldu.',
                timestamp: Date.now()
            });
            isletimSistemiBildirimi(
                'İşlemler durduruldu',
                'UYAP bağlantısında tekrarlayan hata; ban riskine karşı işlemler durduruldu.'
            );
            uyariSesi();
        },
        devreKesiciUyarisiniKapat(ctx: ActionContext<AppState, AppState>) {
            ctx.commit('setDevreKesiciUyarisi', null);
        },
        /**
         * UYAP insan doğrulaması istedi (DEV-3572; plugin kancasının hedefi). PLUGIN kilidi bu noktada ZATEN
         * kurulmuştur (kanca kilit KURULURKEN çağrılır; host plugin kilidini KURMAZ) ve botu plugin
         * `uyapEngeliBotuDurdur` ile durdurur (host DURDURMAZ: çift PUT DURAKLATILDI ve çift 'durduruluyor' olmasın).
         * Sıra: senkron kilit → sessionStorage → TEK bildirim + ses → kimlik duraklatma anısını sil → panele geçici
         * duyuru ('sunucu' kaynağında yok). Uyarı penceresi ilk commit'te açılır (playerStop PUT'ları yavaş olabilir).
         * Durum satırına (uyapStatusMessage) UYAP metni YAZILMAZ, botBeklemeSebebi'ne dokunulmaz, bağlı bayrağı
         * (`setUyapConnection`) değişmez.
         */
        async uyapEngeliGoster(ctx: ActionContext<AppState, AppState>, bilgi: UyapEngelBilgisi): Promise<void> {
            // Hızlı kilit: SENKRON (ilk await'ten önce); eşzamanlı çağrılar ve ikinci engel girmez.
            if (ctx.state.uyapEngeli !== null) {
                return;
            }
            const kaynak: UyapEngelKaynagi = bilgi && (bilgi.kaynak === 'yoklama' || bilgi.kaynak === 'sunucu')
                ? bilgi.kaynak
                : 'gorev';
            // `mesaj` `metin`'in takma adıdır; yeni kod `metin` okur.
            const metin = bilgi && typeof bilgi.metin === 'string'
                ? bilgi.metin
                : (bilgi && typeof bilgi.mesaj === 'string' ? bilgi.mesaj : '');
            const engel: UyapEngeli = {
                zaman: bilgi && typeof bilgi.zaman === 'number' && isFinite(bilgi.zaman) && bilgi.zaman > 0
                    ? bilgi.zaman
                    : Date.now(),
                mesaj: engelMesajiniTemizle(metin),
                kaynak,
                diyalogAcik: true
            };
            ctx.commit('setUyapEngeli', engel);
            uyapEngeliniYaz(oturumDeposu(), engel);
            isletimSistemiBildirimi(UYAP_ENGEL_METINLERI.bildirimBaslik, UYAP_ENGEL_METINLERI.bildirimGovde);
            uyariSesi();
            // Engel varken kimlik düzelince bot otomatik 'oto'ya dönmesin.
            ctx.commit('setKimlikDuraklatmasi', null);
            // Sunucu freninde panel zaten sunucunun Waiting metnini alıyor.
            if (kaynak !== 'sunucu') {
                engeliPanelinDuyur(engel.zaman);
            }
        },
        /**
         * Kilidi kaldırır (YALNIZ kullanıcı eylemi: diyalogda "Yeniden denemeye izin ver", onaylı Başlat, panelden
         * gelen çıplak SAYI 0). Hiçbir otomatik yol çağırmaz. Senkron kısım: state, sessionStorage, plugin kilidi
         * (`kaynak` eşlemesi: diyalog→'izin', baslat→'baslat', panel→'panel'), kilit altında bastırılan tetikleyicilerin
         * sayaçları. `botGirisZamanlari` (saatlik giriş sınırı) SIFIRLANMAZ. Sonra sunucu freninin kaldırılması: HER
         * `kaynak` için kendi DELETE'i ≤3 sn BEKLENİR (panelin DELETE'i zaten atılmış olsa da: çift DELETE idempotent;
         * panel imzacının kilidini bilmiyorsa fren yarışı kalmasın).
         */
        async uyapEngeliniKaldir(
            ctx: ActionContext<AppState, AppState>,
            payload?: { kaynak?: 'diyalog' | 'baslat' | 'panel' }
        ): Promise<void> {
            if (ctx.state.uyapEngeli === null && !uyapEngelKilidiAktifMi()) {
                return;
            }
            const kaynak = payload && payload.kaynak ? payload.kaynak : 'diyalog';
            ctx.commit('setUyapEngeli', null);
            uyapEngeliniSil(oturumDeposu());
            uyapEngelKilidiniKaldir(kaynak === 'diyalog' ? 'izin' : kaynak);
            // Kilit altında bastırılan tetikleyiciler (updateToken, kart takılması...) kalkınca yeni devralma
            // yoklaması yapabilsin; geri çekilme sayaçları temiz başlasın. Saatlik giriş sınırına DOKUNULMAZ.
            sonOturumYoklamasi = 0;
            oturumYoklamasiOlumsuz = false;
            sonGecerliKurtarmaDogrulamasi = null;
            otoGirisBasarisizSayisi = 0;
            otoGirisSonrakiDenemeZamani = 0;
            await ctx.dispatch('uyapEngelFreniniKaldir', {neden: kaynak === 'diyalog' ? 'yeniden_deneme' : 'baslat_onayi'});
        },
        /**
         * Diyalogdaki "Yeniden denemeye izin ver" (ONAYSIZ: düğmenin etiketi onaydır) ve onaylı Başlat: kilidi
         * kaldır + yerel 'oto' + 'oto' yayını. 'oto' ANCAK kaldırma (DELETE ≤3 sn dahil) tamamlandıktan SONRA yayınlanır
         * ve kullanıcı eylemi olduğu için çıplak SAYI 0'dır (`String()`/`Number()` sarması YOK; sözleşme §4.5 tür kuralı).
         * Kaldırma beklenirken (kapılar açık, DELETE ≤3 sn) bir UYAP isteği engele yeniden çarpıp YENİ kilit kurduysa
         * o kilit kullanıcıya kalır: 'oto' ne uygulanır ne yayınlanır (yayınlansaydı kabuğun SAYI 0 yankısı yeni kilidi
         * yeniden onaysız kaldırırdı; diyalog, kayıt ve plugin kilidi yerinde kalır). Dönüş: 'oto' yayınlandı mı.
         */
        async uyapEngeliniKaldirVeBaslat(
            ctx: ActionContext<AppState, AppState>,
            payload?: { kaynak?: 'diyalog' | 'baslat' }
        ): Promise<boolean> {
            await ctx.dispatch('uyapEngeliniKaldir', payload);
            if (uyapEngelliMi(ctx)) {
                return false;
            }
            ctx.commit('setPlayerDurum', PlayerDurum.oto);
            app.$socket.client.emit('player', PlayerDurum.oto);
            return true;
        },
        /**
         * Sunucu freninin kaldırılması: `DELETE /api/v1/uyap-engel?neden=...` (gövde ve yeni başlık YOK; sunucu freni
         * v1'de herkese KAPALI çıkar, bu çağrı fren açıldığında anlam kazanır). ASLA fırlatmaz (200/401/403/404/405/
         * 503/ağ hataları yutulur: fail-open, yerel kilit her koşulda kalkar); en çok 3 sn beklenir; kimlik yokken
         * atılmaz (proxy hedefi boş).
         */
        async uyapEngelFreniniKaldir(
            ctx: ActionContext<AppState, AppState>,
            payload?: { neden?: 'yeniden_deneme' | 'baslat_onayi' }
        ): Promise<void> {
            if (!eicraproBagli(ctx)) {
                return;
            }
            const neden = payload && payload.neden === 'baslat_onayi' ? 'baslat_onayi' : 'yeniden_deneme';
            let zamanlayici: number | undefined;
            try {
                await Promise.race([
                    app.$http.delete(UYAP_ENGEL_FREN_YOLU, {
                        params: {neden},
                        sessiz: true,
                        timeout: UYAP_ENGEL_FREN_ZAMAN_ASIMI_MS
                    }),
                    new Promise((cozum) => {
                        zamanlayici = window.setTimeout(cozum, UYAP_ENGEL_FREN_ZAMAN_ASIMI_MS);
                    })
                ]);
            } catch (e) {
                console.warn('UYAP engel freni kaldırma isteği başarısız (önemsiz; fren süre dolunca kalkar):', e);
            } finally {
                if (zamanlayici !== undefined) {
                    window.clearTimeout(zamanlayici);
                }
            }
        },
        /**
         * Kullanıcı Başlat'ının TEK geçidi (DevamEdenGorevList + 15 detay görünümü; Panel'de AYNI ad ve AYNI sonuç).
         * true = 'oto' yayınlandı; Vazgeç = false (Dene'de kaldırma sırasında yeniden kilit kurulduysa da false:
         * yeni kilit kullanıcıya kalır). Kilit yoksa bugünkü davranış (onaysız, doğrudan çıplak SAYI 0
         * yayını). Kilit varsa onay ("Yeniden denensin mi?"): Dene → kilit kalkar (DELETE ≤3 sn), SONRA 'oto' yayını.
         * `socketClient` bileşenlerin `this.$socket.client`'ıdır (verilmezse `app.$socket.client`).
         */
        async playerBaslatOnayli(
            ctx: ActionContext<AppState, AppState>,
            socketClient?: { emit: (olay: string, ...arguman: unknown[]) => unknown }
        ): Promise<boolean> {
            const istemci = socketClient || app.$socket.client;
            return baslatIsteginiIsle({
                engelVar: () => ctx.getters.uyapEngeliKilitli === true,
                onayIste: uyapEngeliBaslatOnayi,
                engeliKaldirVeBaslat: () => ctx.dispatch('uyapEngeliniKaldirVeBaslat', {kaynak: 'baslat'}),
                baslat: () => {
                    istemci.emit('player', PlayerDurum.oto);
                }
            });
        },
        /**
         * Socket 'player' olayının TEK girişi (App.vue onPlayer). Karar saf: `playerOlayiKarari` (sözleşme §4.5).
         * 'oto' commit'i (`setPlayerDurum`) anında next-task tetikler: UYAP engeli kilidi VARKEN otomatik 'oto'
         * (metin "0": plugin autoPlayer, kabuğun yeniden oynatması) commit EDİLMEZ. Yalnız `kaldir-uygula` kolu
         * bekler (kendi fren DELETE'i ≤3 sn); diğer kollar senkrondur (olay sırası bugünkü gibi). Beklerken daha yeni bir
         * `player` olayı işlendiyse (ör. kullanıcının hemen Durdur'u) bayat 'oto' UYGULANMAZ (`playerOlaySirasi`).
         */
        async playerOlayiniIsle(ctx: ActionContext<AppState, AppState>, ham: unknown): Promise<void> {
            const sira = ++playerOlaySirasi;
            const karar = playerOlayiKarari(ham, uyapEngelliMi(ctx));
            if (karar === 'yoksay') {
                return;
            }
            if (karar === 'reddet') {
                // Tutarsız 'oto' durumunda yeniden durdurma `uyapEngeliniKaldir`ın aksine BEKLENMEZ.
                engelVarkenOtoyuReddet(ctx);
                return;
            }
            if (karar === 'kaldir-uygula') {
                await ctx.dispatch('uyapEngeliniKaldir', {kaynak: 'panel'});
                if (sira !== playerOlaySirasi) {
                    return;
                }
                // Kaldırma beklenirken yeniden kilit kurulduysa (bkz. uyapEngeliniKaldirVeBaslat) o kilit kullanıcıya
                // kalır: bu 'oto' uygulanmaz, kilit/diyalog/kayıt yerinde kalır; panel 'oto' sandığı için 'reddet'
                // gibi geri döndürülür.
                if (uyapEngelliMi(ctx)) {
                    engelVarkenOtoyuReddet(ctx);
                    return;
                }
            }
            ctx.commit('setPlayerDurum', Number(ham));
            // Kullanıcı Başlat'a bastı: kimlik uyuşmazlığının duraklatma anısı silinir (sonraki oturum doğrulaması
            // player'a dokunmaz). Kendi 'durduruluyor'/'dur' yankılarımız anıyı silmez.
            if (Number(ham) === PlayerDurum.oto) {
                ctx.commit('setKimlikDuraklatmasi', null);
            }
        },
        /**
         * Açık UYAP oturumu bu hesaba ait değil ya da sunucu 423 verdi. GÜVENLİK OLAYI, engelleyici.
         *
         * Bot DURAKLATILIR (görev BITTI_HATALI olmaz): bağlantı bayrağı düşürülür, engelleyici
         * dialog + işletim sistemi bildirimi + ses verilir, süren üst görev ESKİ kimlikle
         * DURAKLATILDI yapılır (oyuncuyuDuraklat: playerStop + 'durduruluyor' yayını; player'ı
         * doğrudan 'dur' commit etmez). Önceki player 'oto' idiyse hatırlanır: oturum doğrulanınca
         * ('hesap'|'kart' sebeplerinde) bot kendiliğinden devam eder (kimlikUyusmazligiGiderildi).
         * Sunucu kararı ('lisans'|'lisans-tckn') istemci karşılaştırmasından farklı olabileceği için
         * otomatik devam YOKTUR; diyalogdaki "Yeniden bağla" lisansı tazeler ve kullanıcı karar verir.
         * Diyalog "Kapat" ile kapanırsa anı da silinir (kimlikUyusmazligiUyarisiniKapat): bot 'dur'
         * kalır, kullanıcı Başlat'a basar.
         * İkinci çağrı (uyarı açıkken) bildirim, ses ve PUT üretmez.
         */
        async kimlikUyusmazligiUyarisiGoster(
            ctx: ActionContext<AppState, AppState>,
            payload?: { sebep?: KimlikUyusmazligiSebebi | null, mesaj?: string }
        ) {
            // Hızlı kilit: SENKRON kurulur (ilk await'ten önce), aynı anda gelen çağrılar girmez.
            if (ctx.state.kimlikUyusmazligiUyarisi) {
                return;
            }
            const sebep: KimlikUyusmazligiSebebi = payload?.sebep ?? 'hesap';
            const sunucuMesaji = typeof payload?.mesaj === 'string' && payload.mesaj.trim() !== ''
                ? payload.mesaj.trim()
                : undefined;
            const oncekiOto = ctx.getters.getPlayerDurum == PlayerDurum.oto;
            ctx.commit('setKimlikUyusmazligiUyarisi', {zaman: Date.now(), sebep, mesaj: sunucuMesaji});
            const metin = (sebep === 'lisans' || sebep === 'lisans-tckn')
                ? (sunucuMesaji ?? 'Sunucu bu e-imza kullanımını lisans sahibine ait bulmadı; işlemler duraklatıldı.')
                : KIMLIK_UYUSMAZLIGI_MESAJI;
            // Bildirim ve ses ağ beklemeden (duraklatma PUT'u yavaş olabilir).
            isletimSistemiBildirimi(
                (sebep === 'lisans' || sebep === 'lisans-tckn')
                    ? 'e-İmza lisans denetimi: işlemler duraklatıldı'
                    : 'UYAP oturumu bu hesaba ait değil',
                (sebep === 'lisans' || sebep === 'lisans-tckn')
                    ? 'Bu büronun eİcraPro lisans sahibinin e-imzasıyla bağlanın.'
                    : 'İşlemler duraklatıldı. Kendi hesabınızla giriş yapıp kendi e-imzanızı kullanın.'
            );
            uyariSesi();
            ctx.commit('setUyapStatusMessage', {
                type: 'error',
                text: metin,
                timestamp: Date.now()
            });
            ctx.commit('setUyapConnection', false);
            if (oncekiOto) {
                ctx.commit('setKimlikDuraklatmasi', {oncekiPlayer: PlayerDurum.oto, zaman: Date.now()});
            }
            await oyuncuyuDuraklat(ctx);
        },
        /**
         * Oturum doğrulandı ve bağlantı kuruldu (connectToUyap, checkUyapSessionNew, fastLoginUyap).
         * 'hesap'|'kart' uyarısı kapanır; kimlik uyuşmazlığı botu duraklattıysa ve player hâlâ
         * dur/durduruluyor ise bot 'oto'ya geri döner (anı silinir). 'lisans*' sebeplerinde
         * otomatik devam YOK; yalnız kullanıcı eylemiyle (`kullanici: true`: diyalogdaki
         * "Yeniden bağla" lisansı tazeleyip bağlandıktan sonra) kapanır ve devam eder.
         */
        kimlikUyusmazligiGiderildi(ctx: ActionContext<AppState, AppState>, payload?: { kullanici?: boolean }) {
            const uyari = ctx.state.kimlikUyusmazligiUyarisi;
            const duraklatma = ctx.state.kimlikDuraklatmasi;
            if (!uyari && !duraklatma) {
                return;
            }
            const lisansSebebi = !!uyari && (uyari.sebep === 'lisans' || uyari.sebep === 'lisans-tckn');
            if (lisansSebebi && payload?.kullanici !== true) {
                return;
            }
            if (uyari) {
                ctx.commit('setKimlikUyusmazligiUyarisi', null);
            }
            if (duraklatma) {
                const oyuncu = ctx.getters.getPlayerDurum;
                // UYAP engeli kilidi açıkken otomatik devam YOK (yerel 'oto' commit'i anında next-task tetikler);
                // anı yine silinir.
                if (duraklatma.oncekiPlayer == PlayerDurum.oto &&
                    (oyuncu == PlayerDurum.dur || oyuncu == PlayerDurum.durduruluyor) && !uyapEngelliMi(ctx)) {
                    ctx.commit('setPlayerDurum', PlayerDurum.oto);
                    app.$socket.client.emit('player', PlayerDurum.oto);
                }
                ctx.commit('setKimlikDuraklatmasi', null);
            }
        },
        /**
         * Uyarı diyaloğunu kapatır ("Kapat" ve "Yeniden bağla"nın finally'si). Sunucu 423'ünde
         * ('lisans'|'lisans-tckn') otomatik devam YOKTUR ve bu koruma yalnız açık uyarıya dayanır:
         * uyarı kapanınca duraklatma anısı da silinir, yoksa sonraki geçerli oturum doğrulaması
         * (sağlık tiki, updateToken) anıyı görüp botu 'oto'ya döndürür, 423 döngüsü (diyalog +
         * bildirim + ses) başlardı. Bot 'dur' kalır, kullanıcı Başlat'a basar. 'hesap'|'kart'
         * sebeplerinde anı korunur: oturum doğrulanınca otomatik devam tasarım gereğidir. Başarılı
         * "Yeniden bağla" `kimlikUyusmazligiGiderildi({kullanici:true})` ile uyarıyı ve anıyı Kapat'tan
         * ÖNCE tüketir ve botu devam ettirir (burada uyarı zaten null: davranış değişmez).
         */
        kimlikUyusmazligiUyarisiniKapat(ctx: ActionContext<AppState, AppState>) {
            const sebep = ctx.state.kimlikUyusmazligiUyarisi?.sebep;
            if (sebep === 'lisans' || sebep === 'lisans-tckn') {
                ctx.commit('setKimlikDuraklatmasi', null);
            }
            ctx.commit('setKimlikUyusmazligiUyarisi', null);
        },
        /**
         * Oturum gerçekten ayakta mı. KullaniciBilgileri önbelleksiz olduğu için canlı testtir.
         *
         * probe() ŞART: bu bir yoklama, iş isteği değil. probe()'suz çağrıldığında
         * UyapRequest 401'i "oturum düştü" sayıp kurtarma turlarına giriyor (3+15+30 sn)
         * ve o kurtarma connectToUyap yayınlıyor — yani burayı çağıran connectToUyap'ın
         * kendisini bekliyor. Sonuç: her "Bağlan" tıklaması 48 sn boşa bekliyordu.
         */
        async uyapOturumuGecerliMi(ctx: ActionContext<AppState, AppState>): Promise<boolean> {
            // Önceki yoklamadan kalan bayat "engel" işareti erken dönüşte de silinir (aksi halde 'Geç' sonrası
            // checkUyapSessionNew bayrak düşürmeyi atlardı).
            sonYoklamaEngelliydi = false;
            // Oturum ESKİ avukata ait ('Geç' sonrası): yoklanmaz, devralınmaz. Yoklama yapılsaydı
            // eski avukatın hâlâ geçerli oturumu sahte "başka hesap" uyarısı üretirdi.
            if (ctx.state.oturumYenilenmeli) {
                return false;
            }
            // Son oturum yoklaması HER yoldan damgalanır: devralma yoklaması (oturumuDevralmayiDene) buna göre
            // hız sınırlanır, giriş denemesi/kurtarma/kimlik sonrası akış yokladıysa yenisi atılmaz.
            sonOturumYoklamasi = Date.now();
            let avukat: KullaniciBilgileriCevap;
            try {
                avukat = await app.$uyap.KullaniciBilgileri().probe().run({});
            } catch (e) {
                // UYAP'ın insan doğrulaması uyarısı 'oturum yok' DEĞİLDİR: olumsuz damga YAZILMAZ (kilit kalkınca
                // devralma yoklaması engellenmesin, e-imzayla YENİ UYAP oturumu açılmasın). Çağıranlar sonucu
                // `sonYoklamaEngelliydi` ile okur.
                if (uyapEngelHatasiMi(e)) {
                    sonYoklamaEngelliydi = true;
                    return false;
                }
                oturumYoklamasiOlumsuz = true;
                return false;
            }

            // Oturum "geçerli" olsa bile YANLIŞ KİMLİĞE ait olabilir.
            // Hesap TC'si AKTİF KİMLİKTEN gelir (lisans sahibinin TCKN'si; ham setConfig
            // anahtarı değil).
            //
            // Denetimden ÖNCE yazılıyor: UyapRequest'teki kimlik kapısı oturumun
            // kime ait olduğunu buradan okuyor. Uyuşmazlıkta yazılmasaydı kapı
            // "bilinmiyor" deyip her isteği geçirirdi.
            ctx.commit('setUyapAvukatBilgileri', avukat);
            const gecerli = oturumKimliginiDenetle(ctx, avukat) === null;
            oturumYoklamasiOlumsuz = !gecerli;
            return gecerli;
        },
        /**
         * Bağlantı kurulduktan sonraki ilk veri yüklemesi.
         *
         * Üç istek de probe(): burası bağlantı kurma yolunun içi. Buradaki bir 401
         * kurtarmayı tetiklerse kurtarma connectToUyap yayınlar, o da hâlâ çalışmakta
         * olan bu çağrıyı bekler — 48 sn'lik kilit. Bu yolda doğru davranış beklemek
         * değil, hatayı çağırana bildirmek.
         */
        async loadUyapMetaData(ctx: ActionContext<AppState, AppState>): Promise<void> {
            const [bakiyeResult, sorguBakiyeResult, kullaniciResult] = await Promise.allSettled([
                app.$uyap.AvukatBakiyeSorgula().probe().run({}),
                app.$uyap.SorguBakiyesi().probe().run({}),
                app.$uyap.KullaniciBilgileri().probe().run({})
            ]);

            // UYAP engeli kilidi altında (kullanıcının elle Bağlan'ı geçerli oturum buldu) muaf olmayan bakiye
            // sorguları kapıda reddedilir: reddedilen alanın ÖNCEKİ değeri korunur (`undefined` commit EDİLMEZ,
            // console.error yok) ve bakiyesiz durum panele yayınlanmaz. Engel olmayan hatalarda davranış eskisi gibidir.
            const engelli = (r: { status: string, reason?: unknown }): boolean =>
                r.status === 'rejected' && uyapEngelHatasiMi(r.reason);
            const bakiyeEngel = engelli(bakiyeResult);
            const sorguEngel = engelli(sorguBakiyeResult);
            const kullaniciEngel = engelli(kullaniciResult);

            if (bakiyeResult.status === "fulfilled") {
                ctx.commit('setUyapAvukatBakiye', (bakiyeResult.value as { value: string }).value);
            } else if (!bakiyeEngel) {
                ctx.commit('setUyapAvukatBakiye', undefined);
                console.error('AvukatBakiyeSorgula failed', bakiyeResult.reason);
            }

            if (sorguBakiyeResult.status === "fulfilled") {
                const sorguBakiye = (sorguBakiyeResult.value as { sorguBakiye: number }).sorguBakiye;
                ctx.commit('setUyapSorguBakiye', String(sorguBakiye));
            } else if (!sorguEngel) {
                ctx.commit('setUyapSorguBakiye', undefined);
                console.error('SorguBakiyesi failed', sorguBakiyeResult.reason);
            }

            if (kullaniciResult.status === "fulfilled") {
                ctx.commit('setUyapAvukatBilgileri', kullaniciResult.value as KullaniciBilgileriCevap);
            } else if (!kullaniciEngel) {
                ctx.commit('setUyapAvukatBilgileri', undefined);
                console.error('KullaniciBilgileri failed', kullaniciResult.reason);
            }

            if (!(bakiyeEngel || sorguEngel || kullaniciEngel)) {
                app.$socket.client.emit("uyapAvukatBilgileri", {
                    uyapAvukatBilgileri: ctx.state.uyapAvukatBilgileri,
                    uyapAvukatBakiye: ctx.state.uyapAvukatBakiye,
                    uyapSorguBakiye: ctx.state.uyapSorguBakiye
                });
            }

            // KullaniciBilgileri oturumun asıl doğrulamasıdır; alınamadıysa oturum
            // geçersizdir ve çağıranlar (connectToUyap, checkUyapSessionNew) bunu bilmeli.
            // Bakiye hataları ise bağlantıyı düşürmez, sessizce geçilir.
            if (kullaniciResult.status === "rejected") {
                const reason = kullaniciResult.reason;
                throw reason instanceof Error ? reason : new Error(String(reason ?? 'UYAP oturumu doğrulanamadı.'));
            }
        },
        async availableCards(ctx: ActionContext<AppState, AppState>, payload?: { silent?: boolean }) {
            console.log("availableCards triggered");
            const silent = Boolean(payload?.silent);
            const oncekiKartVarMi = (ctx.state.availableCardList?.length ?? 0) > 0;
            try{
                let data = await app.$imza.availableCards();
                //console.log("data availableCards",data);
                ctx.commit('setAvailableCardList', data);
                // Program yanıt verdi (kart olsun olmasın): bot bekleme nedeni KART_YOK kalır.
                ctx.commit('setImzaProgramiKapali', false);
                if (Array.isArray(data) && data.length > 0) {
                    const current = ctx.state.selectedCardSerial;
                    // Yeni yapıda kart kimliği card.certificate.certificateId
                    const match = data.find((card: any) => card?.certificate?.certificateId === current);
                    ctx.commit(
                        'setSelectedCardSerial',
                        match ? current : hesabaAitKartiSec(data, ctx.getters.hesapTckn)
                    );
                    // 'İ'.toLowerCase() 'i'+U+0307 ürettiği için Türkçe metinlerde
                    // includes eşleşmesi kaçar; tr locale ile küçült.
                    const currentMessage = ctx.state.uyapStatusMessage?.text?.toLocaleLowerCase('tr') ?? '';
                    // PIN mesajları (yanlış/kilitli PIN) 'kart' geçse de kart takılınca çözülmez: silinmez.
                    const pinMesaji = /p[iı]n/.test(currentMessage);
                    if (!pinMesaji && (currentMessage.includes('kart') || currentMessage.includes('imzacı') || currentMessage.includes('program'))) {
                        ctx.commit('setUyapStatusMessage', null);
                    }
                    // Kart YENİ takıldı (boş → dolu): otomatik girişin tek tetikleyicisi.
                    // "kart takılı" durumu değil, GEÇİŞ tetikliyor; aksi halde her
                    // yoklama yeni bir giriş denemesi olurdu.
                    if (!oncekiKartVarMi) {
                        ctx.dispatch('otomatikGirisDene', {kartGecisi: true})
                            .catch((e) => console.error('Kart takılma akışı:', e));
                    }
                } else {
                    ctx.commit('setSelectedCardSerial', null);
                }
                if (!silent) {
                    //app.$toast.success('Kart listesi alındı');
                }
            }catch (e) {
                console.log("CATCH E",e);
                const errMsg = e instanceof Error ? e.message : String(e);
                ctx.commit('setAvailableCardList', []);
                ctx.commit('setSelectedCardSerial', null);
                // E-İmza programı kapalı mı (bot bekleme nedeni): plugin hata koduyla bildirir,
                // eski mesajlarda "program" kelimesine bakılır (tr küçük harf).
                ctx.commit('setImzaProgramiKapali',
                    (e as any)?.kod === 'IMZA_PROGRAMI_KAPALI' || errMsg.toLocaleLowerCase('tr').includes('program'));
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: errMsg,
                    timestamp: Date.now()
                });
                if (!silent) {
                    app.$toast.error(errMsg);
                }
            }
        },
        /**
         * Kart yeni takıldı (liste boş → dolu). Otomatik girişin tek tetikleyicisi.
         *
         * Kapılar — hepsi ban ve yanlış-kimlik riskine karşı:
         *  - Devre kesici açıksa hiç denenmez (kullanıcı bilinçli olarak sıfırlamalı).
         *  - Oturum kotası doluysa denenmez; UYAP zaten yeni oturum vermiyor.
         *  - Kart belirsizse (çoklu kart, TCKN eşleşmesi yok) denenmez; seçim kullanıcıda.
         *  - Kart hesaba (lisans sahibinin TCKN'si) ait değilse ya da kartın TCKN'si
         *    okunamıyorsa denenmez; aksi halde arka planda tekrar tekrar "İzinsiz İmza"
         *    uyarısı açılırdı.
         *  - PIN kayıtlı değilse denenmez: otomatik akış kullanıcıya PIN modalı açmaz,
         *    kullanıcı "Bağlan"a bastığında zaten sorulur ve bir daha sorulmaz.
         *  - Geri çekilme: art arda başarısızlıkta yeniden deneme aralığı büyür.
         * connectToUyap ayrıca kendi içinde oturumu yokluyor; geçerli oturum varken
         * yeni oturum AÇILMAZ (UYAP'ta en fazla 5 aktif oturum).
         */
        async otomatikGirisDene(
            ctx: ActionContext<AppState, AppState>,
            payload?: { kartGecisi?: boolean, oturumuYenidenYokla?: boolean }
        ) {
            // Kart yeni takıldı: durum değişti, önceki başarısızlıkların hükmü kalktı.
            if (payload?.kartGecisi) {
                otoGirisBasarisizSayisi = 0;
                otoGirisSonrakiDenemeZamani = 0;
            }
            // Tetikleyici (kart takılması, yeni kimlik, tarayıcıdan updateToken): önceki olumsuz oturum
            // yoklaması geçersiz, devralma yeniden denenebilir. Sağlık tiki bunu vermez.
            if (payload?.kartGecisi || payload?.oturumuYenidenYokla) {
                devralmaYoklamasiniAc();
            }
            // Kapılar, geri çekilme ve sayaçlar sessizGirisDene'de (bot yeniden bağlanmasıyla ortak).
            await sessizGirisDene(ctx, 'otomatik');
        },
        /**
         * Bot döngüsünün UYAP bağlantısını SÜRDÜRMESİ (DEV-3898). Plugin dongu bağlantı düşünce
         * ve player 'oto' iken çağırır: `dur` commit YOK, toast YOK, islemDurum/enSonIslenenGorev'e
         * dokunulmaz (askıdaki görev kaldığı yerden sürer). Kapıları (kimlik, devre kesici, kota, kart,
         * TCKN, PIN, geri çekilme, saatlik tavan) sessizGirisDene uygular; engel insan gerektiriyorsa
         * bekleme nedeni (botBeklemeSebebi) olur ve bölüm başına BİR bildirim verilir. Mevcut UYAP
         * oturumu kart/PIN'e bakılmadan DEVRALINIR (oturumuDevralmayiDene, hız sınırlı). Bekleme
         * sırasında e-imza girişi denenmez; UYAP'a yalnız o hız sınırlı yoklama gider. Tek uçuş. Çağıranlar: plugin dongu (yük yok), imzacı
         * kurtarma kancası ({kaynak:'kurtarma'}) ve `tarayiciKurtarmasiniSurdur` (tarayıcı kaynaklı
         * kurtarma isteği; bayat "bağlı" bayrağını önce canlı doğrular).
         */
        async botBaglantisiniSurdur(ctx: ActionContext<AppState, AppState>): Promise<void> {
            if (botGirisUcusu) {
                return botGirisUcusu;
            }
            botGirisUcusu = (async () => {
                try {
                    await sessizGirisDene(ctx, 'bot');
                } catch (e) {
                    console.error('Bot UYAP bağlantısını sürdüremedi:', e);
                } finally {
                    botGirisUcusu = null;
                }
            })();
            return botGirisUcusu;
        },
        /**
         * Tarayıcıdaki eİcraPro'nun UYAP oturum kurtarma isteği (socket `connectToUyap`,
         * `{kaynak:'kurtarma'}`; App.vue). Tarayıcı kendi bayrağını 401'de düşürüp imzacıdan yeniden
         * bağlanmasını ister. İmzacı UYAP'a boşta hiç istek atmadığı için KENDİ "bağlı" bayrağı bayat
         * (true) olabilir; bayrağa güvenilseydi `sessizGirisDene` "zaten bağlı" diye dönerdi: ne giriş
         * ne 'uyapconnection' yayını olur, tarayıcı sonsuza dek beklerdi (DEV-2603 inceleme B1).
         *
         * Bayrak true ise oturum CANLI doğrulanır (tek uçuş, geçerli sonuç en çok
         * KURTARMA_DOGRULAMA_ARALIK_MS'de bir yoklanır):
         *  - geçerli: durum socket'e yeniden yayınlanır (`setUyapConnection(true)` mutation'ı yayınlar),
         *    tarayıcının bayat 'bağlı değil' bayrağı düzelir; giriş yapılmaz;
         *  - geçersiz: bayrak düşürülür (tarayıcıya da yayınlanır) ve `botBaglantisiniSurdur`a ilerlenir:
         *    kapılar, geri çekilme, saatlik tavan, sessiz yol ve PIN kuralı aynen geçerlidir.
         * Bayrak false ise doğrudan `botBaglantisiniSurdur`. Süren bir giriş varsa dokunulmaz: o deneme
         * bağlantıyı ve yayını kendisi bitirir.
         */
        async tarayiciKurtarmasiniSurdur(ctx: ActionContext<AppState, AppState>): Promise<void> {
            // UYAP engeli kilidi açıkken bayrak true iken bile yoklamaz, düşürmez, yeniden yayınlamaz.
            if (uyapEngelliMi(ctx)) {
                return;
            }
            if (ctx.getters.isUyapConnecting) {
                return;
            }
            if (ctx.getters.isUyapConnected) {
                const gecerli = await kurtarmaOturumuGecerliMi(ctx);
                // Yoklama sürerken bayrağı başka bir yol (güvenlik olayı, kimlik geçişi) düşürdüyse
                // geçerli sonuç onu geri açmaz: doğrulanan oturumdan sonra durum değişmiştir.
                if (ctx.getters.isUyapConnected) {
                    if (gecerli) {
                        ctx.commit('setUyapConnection', true);
                        return;
                    }
                    // Yoklama engele çarptıysa 'oturum yok' DEĞİL: bayrak düşürülmez, giriş denenmez.
                    if (sonYoklamaEngelliydi) {
                        return;
                    }
                    ctx.commit('setUyapConnection', false);
                }
            }
            await ctx.dispatch('botBaglantisiniSurdur', {kaynak: 'kurtarma'});
        },
        /**
         * Görev listesini sunucudan çeker; devir patlamaları (updateToken + tarayıcının
         * updateTasks yayını) tek GET /api/v1/task'a birleşir (ilk çağrı gecikmesiz).
         */
        gorevListesiniTazele(ctx: ActionContext<AppState, AppState>): Promise<void> {
            if (gorevTazeleBirlestirici === null) {
                gorevTazeleBirlestirici = tekUcusluBirlestir(() => ctx.dispatch('updateTasks'));
            }
            return gorevTazeleBirlestirici();
        },
        /**
         * Kart gözlemcisi. Kart takılmasını gören tek yer burası.
         *
         * Yoklama YEREL imzalama uygulamasına gidiyor (127.0.0.1:5975, proxy 6075),
         * UYAP'a değil — bu yüzden sık yoklama ban riski taşımaz. Yine de kart
         * takılıyken sık yoklamanın faydası yok: kart yokken 3 sn, varken 30 sn.
         * Sekme arka plandayken hiç yoklanmaz.
         */
        kartGozlemcisiniBaslat(ctx: ActionContext<AppState, AppState>) {
            if (kartGozlemciTimer !== null) {
                return;
            }
            // document.hidden'a BAKILMAZ: uygulama simge durumuna küçültülmüşken de
            // bot çalışıyor ve kart o sırada takılabiliyor. Yoklama yerel ve ucuz.
            const tik = async () => {
                // Giriş sürerken yoklama yapılmaz: /getCertificates ile /sign aynı
                // token'ı kullanıyor ve sertifika sorgusu kart kullanıldıktan sonra
                // ~4 sn sürüyor; imzalamayı bekletmesin.
                if (ctx.getters.isUyapConnecting) {
                    return;
                }
                const kartVar = (ctx.state.availableCardList?.length ?? 0) > 0;
                const aralik = kartVar ? KART_YOKLAMA_KART_VAR_MS : KART_YOKLAMA_KART_YOK_MS;
                if (Date.now() - sonKartYoklamasi < aralik) {
                    return;
                }
                sonKartYoklamasi = Date.now();
                await ctx.dispatch('availableCards', {silent: true});
            };
            kartGozlemciTimer = window.setInterval(() => {
                tik().catch((e) => console.error('Kart yoklaması başarısız:', e));
            }, KART_YOKLAMA_TIK_MS);
        },
        kartGozlemcisiniDurdur() {
            if (kartGozlemciTimer !== null) {
                clearInterval(kartGozlemciTimer);
                kartGozlemciTimer = null;
                sonKartYoklamasi = 0;
            }
        },
        selectSmartCard(ctx: ActionContext<AppState, AppState>, serial: string | null) {
            ctx.commit('setSelectedCardSerial', serial);
        },
        openUyapWindow() {
            window.open('https://avukatbeta.uyap.gov.tr/', "_blank");
        },
        async fastLoginUyap(ctx: ActionContext<AppState, AppState>) {
            // Oturum testi uyapOturumuGecerliMi ile (probe(): kurtarmaya girmez, bkz. orası) ve
            // KİMLİK DENETİMİYLE: geçerli oturum başka hesaba aitse "bağlı" sayılmaz.
            if (await ctx.dispatch('uyapOturumuGecerliMi')) {
                ctx.commit('setUyapConnection', true);
                ctx.dispatch('kimlikUyusmazligiGiderildi');
            } else {
                // Yoklama UYAP'ın engeline çarptıysa (oturum yok DEĞİL): e-imza girişine düşülmez.
                if (sonYoklamaEngelliydi) {
                    return;
                }
                // Oturum geçersiz ya da hesaba ait değil: tam e-imza girişine düş.
                await ctx.dispatch('connectToUyap');
                return;
            }
            // Oturum yukarıda doğrulandı; meta verideki geçici bir hata tam
            // e-imza girişine (PIN dialogu) tırmandırılmamalı.
            await ctx.dispatch('loadUyapMetaData').catch((e) => console.error('UYAP meta verisi yüklenemedi:', e));
        },
        async checkUyapSessionNew(ctx: ActionContext<AppState, AppState>) {
            console.log("checkUyapSessionNew triggered");
            // UYAP engeli kilidi açıkken oturum yoklaması YOK; "bağlı" bayrağına dokunulmaz.
            if (uyapEngelliMi(ctx)) {
                return;
            }
            try {
                // Kimlik değişmiş olabilir (aktif kimlik yeni hesaba geçti): oturumun hesaba
                // (lisans TCKN'si) ait olduğu doğrulanmadan bağlı sayılmamalı, aksi halde bir
                // avukatın UYAP oturumuyla başkasının görevleri işlenir.
                if (!await ctx.dispatch('uyapOturumuGecerliMi')) {
                    // Yoklama UYAP'ın engeline çarptıysa 'oturum yok' DEĞİL: bayrak düşürülmez.
                    if (sonYoklamaEngelliydi) {
                        return;
                    }
                    ctx.commit('setUyapConnection', false);
                    return;
                }
                await ctx.dispatch('loadUyapMetaData');
                ctx.commit('setUyapConnection', true);
                ctx.dispatch('kimlikUyusmazligiGiderildi');
            } catch (error) {
                // loadUyapMetaData engele çarptıysa da bayrak düşürülmez.
                if (uyapEngelHatasiMi(error)) {
                    return;
                }
                ctx.commit('setUyapConnection', false);
            }
        },
        async checkUyapSession(ctx: ActionContext<AppState, AppState>) {
            console.log("checkUyapSession triggered");
            // fastLoginUyap geçerli bir UYAP oturumunu devralıyor; eİcraPro kimliği
            // gelmeden bunu da yapma.
            if (!eicraproBagli(ctx)) {
                return;
            }
            // UYAP engeli kilidi açıkken oturum yoklaması YOK (kartta "Yenile" düğmesi de gizlenir).
            if (uyapEngelliMi(ctx)) {
                return;
            }
            try {
                if (ctx.getters.isEicraproDevMode) {
                    ctx.commit('setUyapConnection', true);
                } else {
                    await app.$imza.setCookieToImza();
                    await ctx.dispatch("fastLoginUyap");
                    ctx.commit('setUyapStatusMessage', {
                        type: 'success',
                        text: 'Uyap oturumu doğrulandı.',
                        timestamp: Date.now()
                    });
                }
            } catch (error) {
                // UYAP engeli: bayrak düşürülmez ve UYAP'ın metni durum satırına yazılmaz.
                if (uyapEngelHatasiMi(error)) {
                    return;
                }
                ctx.commit('setUyapConnection', false);
                const message = `Uyap oturumu doğrulanamadı. ${String(error ?? '')}`.trim();
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: message,
                    timestamp: Date.now()
                });
            }
        },
        async setTasksSocket(ctx: ActionContext<AppState, AppState>) {
            // context.di/getTasksFromServer
            await ctx.dispatch("getTasksFromServer")
            app.$socket.client.emit("tasks", ctx.getters.getGorevler);
        },
        async load(ctx: ActionContext<AppState, AppState>): Promise<void> {
            ctx.commit("setAppState", AppStatus.loading);
            // Pencere yenilendiyse aktif kimlik sessionStorage'dan geri yüklenir ve ham öneri
            // (yenilenmiş token olabilir) yeniden değerlendirilir; yeniden devir beklenmez.
            // await EDİLMEZ: lisans sorgusu açılışı geciktirmesin.
            ctx.commit('aktifKimligiGeriYukle');
            ctx.dispatch('kimlikOnerisiniIsle', {neden: 'yukleme'}).catch((e) => console.error('Kimlik önerisi işlenemedi:', e));
            if (!window.zirvelib) {
                return ctx.commit('setAppState', AppStatus.browser);
            } else {
                const updateRequires = !await ctx.dispatch('isLocalUpToDate');
                console.log("updateRequires", updateRequires);
                if (updateRequires) {
                    return ctx.commit('setAppState', AppStatus.update);
                }
                try {
                    if (!await ctx.dispatch('checkSignService')) {
                        await ctx.dispatch('startSignService');
                    }
                    if (!await ctx.dispatch('checkProxyService')) {
                        await ctx.dispatch('startProxyService');
                    }
                    return ctx.commit('setAppState', AppStatus.electron);
                } catch (e) {
                    console.log(e);
                    return ctx.commit('setAppState', AppStatus.error);
                }
            }
        },
        async isLocalUpToDate(): Promise<boolean> {
            return new Promise((resolve) => {
                if (!window.zirvelib) {
                    return resolve(false);
                }
                if (!window.zirvelib?.version) {
                    return resolve(false);
                }
                console.log("window.zirvelib.version", window.zirvelib.version);
                return resolve(
                    window.zirvelib.version === "2.0.0"
                );
            });
        },

        async checkSignService(): Promise<boolean> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                const heartbeatPromise = axios.post('http://127.0.0.1:4723/xml/heartbeat', {});
                heartbeatPromise.then(() => {
                    console.log('Sign service is running');
                    resolve(true);
                }).catch((error) => {
                    console.warn('Sign service check failed:', error.message);
                    resolve(false);
                });
            })
        },
        async checkProxyService(): Promise<boolean> {
            return new Promise((resolve) => {
                const heartbeatPromise = axios.post('https://imza.eicrapro.com:6090/xml/heartbeat', {});
                heartbeatPromise.then(() => {
                    console.log('Proxy service is running');
                    resolve(true);
                }).catch((error) => {
                    console.warn('Proxy service check failed:', error.message);
                    resolve(false);
                });
            });
        },
        async startSignService(ctx: ActionContext<AppState, AppState>): Promise<void> {
            console.log("Starting Sign Service");
            if (!window.zirvelib) {
                throw new Error('zirvelib not found');
            }
            window.zirvelib.signManager.start();
            // Sabit 2000 ms uyku yerine hazır olmayı yokla: servis 300 ms'de kalkarsa
            // 300 ms beklenir, 3 sn sürerse erken devam edilmez.
            await servisiBekle(() => ctx.dispatch('checkSignService'));
        },

        async startProxyService(ctx: ActionContext<AppState, AppState>): Promise<void> {
            if (!window.zirvelib) {
                throw new Error('zirvelib not found');
            }
            window.zirvelib.proxyManager.start();
            window.zirvelib.socketManager.start();
            await servisiBekle(() => ctx.dispatch('checkProxyService'));
        },

        async stopSignService(): Promise<void> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.signManager.kill();
                window.setTimeout(() => {
                    resolve();
                }, 1500)
            })
        },
        async stopProxyService(): Promise<void> {
            return new Promise((resolve, reject) => {
                if (!window.zirvelib) {
                    return reject('zirvelib not found');
                }
                window.zirvelib.proxyManager.stop();
                window.zirvelib.socketManager.stop();
                resolve();
            })
        },
        /**
         * İmza servisi (6090 -> 4723) canlılık yoklaması.
         *
         * connectToUyap ÇAĞIRMAZ: Java login yolunda değil (login 6075 + 6081
         * üzerinden), ölü olması oturumun geçersiz olduğu anlamına gelmez.
         * Oturum kurtarma UyapRequest ve GorevYoneticisi içinde zaten var.
         */
        async checkHeartbeat(ctx: ActionContext<AppState, AppState>): Promise<boolean> {
            let canli = false;
            try {
                const response = await fetch('https://imza.eicrapro.com:6090/xml/heartbeat', {
                    method: 'POST',
                    credentials: 'include'
                });
                canli = response.ok;
            } catch (error) {
                console.error('İmza servisi yoklaması başarısız:', error);
            }

            ctx.commit('setSonImzaProbe', {basarili: canli, zaman: Date.now()});

            if (canli) {
                ctx.commit('setHealthCheckRetryCount', 0);
                return true;
            }

            const hata = (ctx.state.healthCheckRetryCount || 0) + 1;
            ctx.commit('setHealthCheckRetryCount', hata);

            // Servisi kendimiz kaldırıyoruz. Eskiden kullanıcıya "ana ekrandan
            // yeniden başlat" deniyordu; o düğme kaldırıldı ve zaten kullanıcının
            // yapacak bir şeyi yoktu — jar sadece imzalama yapıyor, yönetimi bize ait.
            //
            // Yukarıdaki yoklama 6090 (Electron proxy) üzerinden gidiyor; proxy ölü
            // olduğunda da başarısız oluyor. signManager.start() İDEMPOTENT DEĞİL,
            // her çağrıda yeni bir java süreci doğuruyor. Bu yüzden yeniden başlatmadan
            // önce java'nın gerçekten ölü olduğu 127.0.0.1:4723'e doğrudan sorularak
            // doğrulanıyor.
            if (hata === 1 && window.zirvelib) {
                const javaAyakta = await ctx.dispatch('checkSignService').catch(() => false);
                if (!javaAyakta) {
                    console.warn('İmza servisi yanıt vermiyor, yeniden başlatılıyor.');
                    try {
                        await ctx.dispatch('startSignService');
                    } catch (e) {
                        console.error('İmza servisi yeniden başlatılamadı:', e);
                    }
                } else {
                    console.warn('Java imza servisi ayakta; 6090 proxy yanıt vermiyor.');
                }
            }

            if (hata === ctx.state.healthCheckMaxRetries) {
                ctx.commit('setUyapStatusMessage', {
                    type: 'error',
                    text: 'İmza servisi yanıt vermiyor ve yeniden başlatılamadı. ' +
                          'Doküman imzalama çalışmayabilir; uygulamayı kapatıp açmayı deneyin.',
                    timestamp: Date.now()
                });
                console.error('İmza servisi yoklaması üst üste başarısız');
            }
            return false;
        },
        startHealthCheck(ctx: ActionContext<AppState, AppState>) {
            // Zaten çalışıyorsa tekrar başlatma
            if (ctx.state.connectionHealthCheckInterval !== null) {
                console.log('Health check zaten çalışıyor');
                return;
            }

            console.log('Health check başlatıldı');

            // Ardışık başarısızlıkta geri çekilme: 30 -> 60 -> 120 sn.
            const TABAN_MS = HEALTH_CHECK_ARALIK_MS;
            const TAVAN_MS = 120000;

            const interval = setInterval(async () => {
                // Kaçan updateToken'a karşı: ham öneri her tikte yeniden değerlendirilir (aynı öneri
                // sıfır istek; lisans sorgusu hatası sonrası en erken 15 sn'de yeniden denenir), ekran
                // (Bağlan düğmesi, görev listesi) en geç bir tikte gerçek kimlik durumuna döner.
                // Bekleyen kimlik geçişi: player 'dur'dayken dongu güvenli noktayı çalıştırmadığı için
                // ancak buradan uygulanır (yalnız bot boştayken; 'tckn' geçişi hiçbir yoldan kendiliğinden olmaz).
                // BEKLENMEZ: yavaş bir lisans sunucusu imza servisi yoklamasını ve oturum gözcüsünü geciktirmesin.
                ctx.dispatch('kimlikOnerisiniIsle', {neden: 'saglik'})
                    .then(() => (ctx.getters.getIslemDurum === IslemDurum.BOSTA ? ctx.dispatch('bekleyenKimligiUygula') : undefined))
                    .catch((e: unknown) => console.error('Kimlik önerisi işlenemedi:', e));
                const hata = ctx.state.healthCheckRetryCount || 0;

                // Bağlıyken normal izleme; bağlantı reconnect denemesi sırasında
                // düştüyse retry penceresi boyunca denemeye devam et — aksi halde
                // ilk başarısız denemeden sonra otomatik kurtarma tamamen durur
                // ve max-retry mesajına hiç ulaşılamaz.
                const retrying = hata > 0 && hata < ctx.state.healthCheckMaxRetries;
                if (ctx.getters.isUyapConnected || retrying) {
                    // Tik sabit olduğu için geri çekilme tik atlayarak uygulanır.
                    // YALNIZCA bu dala uygulanır: geri çekilme imza servisi
                    // yoklamasına ait, oturum gözcüsünün kendi geri çekilmesi var
                    // ve ikisi birbirini yavaşlatmamalı.
                    if (hata > 0) {
                        const beklenenMs = Math.min(TABAN_MS * Math.pow(2, hata), TAVAN_MS);
                        const atlanacakTik = Math.round(beklenenMs / TABAN_MS);
                        healthTikSayaci++;
                        if (healthTikSayaci % atlanacakTik !== 0) {
                            return;
                        }
                    }
                    await ctx.dispatch('checkHeartbeat');
                    return;
                }

                // Oturum gözcüsü: kart takılı ama oturum yok. Kart takılma olayı
                // (boş → dolu geçişi) bu durumu kapsamıyor — kart yerinde dururken
                // oturum düşmüş olabilir. otomatikGirisDene kendi kapılarını
                // (devre kesici, PIN, kart belirsizliği, geri çekilme) uyguluyor.
                await ctx.dispatch('otomatikGirisDene');
            }, TABAN_MS);

            ctx.commit('setHealthCheckInterval', interval);
        },
        stopHealthCheck(ctx: ActionContext<AppState, AppState>) {
            if (ctx.state.connectionHealthCheckInterval !== null) {
                clearInterval(ctx.state.connectionHealthCheckInterval);
                ctx.commit('setHealthCheckInterval', null);
                ctx.commit('setHealthCheckRetryCount', 0);
                healthTikSayaci = 0;
                console.log('Health check durduruldu');
            }
        },
        // kimlikOnerisiniIsle, bekleyenKimligiUygula, kimlikGecisiniBaslat, kimlikGecisiniYoksay,
        // kimlikTokeniGecersizBildir, botKimligiYayinla (store/aktifKimlik.ts).
        ...aktifKimlikActions
    }
})

// UYAP engeli (insan doğrulaması) kancası: store oluşur oluşmaz, HERHANGİ bir UYAP isteğinden ÖNCE kaydedilir.
// Plugin kancası kayıtsızsa özelliği tamamen KAPALI tutar (tanıma, kapı, kilit, bot durdurma): bu kayıt özellik
// anahtarıdır. Kanca yalnız arayüzden sorumludur: botu DURDURMAZ (tek sahip plugin `uyapEngeliBotuDurdur`) ve
// plugin kilidini KURMAZ.
uyapEngelKancasiniAyarla((bilgi: UyapEngelBilgisi) => {
    Promise.resolve(store.dispatch('uyapEngeliGoster', bilgi))
        .catch((e: unknown) => console.warn('UYAP engeli uyarısı gösterilemedi:', e));
});
// Pencere yenilemede geri yüklenen kayıt için plugin kilidi: SESSİZ (kanca ÇAĞRILMAZ, bot durdurulmaz; bildirim ve
// ses yok; açılış kararı 'dur'). SIRA ZORUNLU: kanca kayıtsızken plugin kilidi geri yüklemeyi reddeder (eski-host
// güvenliği) ve geri yükleme sessizce başarısız olurdu.
if (store.state.uyapEngeli !== null) {
    uyapEngelKilidiniGeriYukle({
        mesaj: store.state.uyapEngeli.mesaj,
        kaynak: store.state.uyapEngeli.kaynak,
        zaman: store.state.uyapEngeli.zaman
    });
}

// Kota dolduğunda uyarıyı göster. Kanca burada kaydediliyor ki BaglantiKurtarma
// store/DOM'a bağlanmasın ve uyap-plugin'i kullanan diğer uygulamalarda da
// sorunsuz çalışsın.
kotaUyarisiKancasiniAyarla(() => {
    store.dispatch('oturumLimitiUyarisiGoster');
});

// 401 devre kesici açıldığında: bot durur, engelleyici dialog açılır.
devreKesiciKancasiniAyarla(() => {
    store.dispatch('devreKesiciUyarisiGoster');
});

// Açık oturum bu hesaba ait değil: UyapRequest isteği hiç göndermeden fırlatır,
// burada bot durdurulup engelleyici dialog açılır.
kimlikUyusmazligiKancasiniAyarla((sebep) => {
    store.dispatch('kimlikUyusmazligiUyarisiGoster', {sebep});
});

// İmzacının KENDİ yeniden bağlanma isteği (UyapRequest kurtarması) kabuğa çıkmadan doğrudan
// buraya gelir. Çıksaydı kabuk olayı tüm istemcilere geri yayınlar, bu uygulamanın kendi
// 'connectToUyap' dinleyicisi görünür (PIN penceresi açan) girişi başlatırdı (gece sorunu) ve
// kabuk <= 2.0.4 olay yükünü atar. bot=true: bot isteği, sessiz giriş; bot=false: arayüz isteği,
// kullanıcı bekliyor, eskisi gibi görünür giriş.
baglantiKurtarmaKancasiniAyarla((bot: boolean) => {
    const istek = bot
        ? store.dispatch('botBaglantisiniSurdur', {kaynak: 'kurtarma'})
        : store.dispatch('connectToUyap');
    // Durum mesajı store'da zaten set edilir; yalnız yakalanmamış reddi engelle.
    Promise.resolve(istek).catch((e: unknown) => console.warn('Bağlantı kurtarma isteği başarısız:', e));
});

// Sıkı kimlik denetimi: imzacıda hesap TCKN'si lisanstan gelir; bilinmeyen hesap/kart/oturum
// TCKN'si UYUŞMAZLIKTIR ve UYAP'a girilmez. Hesap TCKN'si AKTİF KİMLİKTEN okunur (lisans sahibi).
// Modül yüklenirken, herhangi bir istekten önce kaydedilir.
sikiModuAyarla(true);
hesapTcknKaynagiAyarla(() => store.getters.hesapTckn);

// Aktif kimlik, bekleyen geçiş ya da avukat adı değişince botKimligi socket'e yayınlanır
// (eİcraPro "Bot: Av. ..." rozeti). Getter içerik değişmedikçe aynı dizeyi döner: token
// yenilemesi gibi içeriği değiştirmeyen güncellemeler yayın üretmez.
store.watch(
    (state: AppState, getters: any) => JSON.stringify(getters.botKimligiYuku),
    () => store.dispatch('botKimligiYayinla')
);

// Bot DURUNCA (Durdur, 'Geç' ve kimlik uyuşmazlığı duraklatması, devre kesici: hepsi setPlayerDurum)
// bekleme bölümü biter. Bekleme nedeni botun nedenidir; durmuş bota "Bot bekliyor, kendiliğinden devam
// eder" demek yalan olur ve bayat sebep sonraki bölümün bildirimini + sesini bastırırdı (botBeklemeyiAyarla
// yalnız sebep null iken bildirir). Başlat'a basılınca dongu engeli yeniden değerlendirir ve yeni bölüm
// başlar. Abonelik mutation'dan hemen sonra (eşzamanlı) çalışır. Aktif kimlik yokken TCKN_EKSIK lisans
// reddidir ve durmaya bağlı değildir (botBeklemeDurdurmadaSilinirMi).
store.subscribe((mutation: MutationPayload, state: AppState) => {
    if (mutation.type !== 'setPlayerDurum' || Number(mutation.payload) === PlayerDurum.oto) {
        return;
    }
    if (botBeklemeDurdurmadaSilinirMi(state.botBeklemeSebebi, state.aktifKimlik !== null)) {
        store.commit('setBotBeklemeSebebi', null);
        store.commit('setBotSonrakiDeneme', null);
    }
});

// Kurtarma sırasındaki durum mesajı. Bu uygulamada UyapStatusCard'da satır içi
// gösteriliyor; icrapro-app aynı kancayı toast'a bağlıyor.
durumMesajiKancasiniAyarla((tip: DurumMesajiTipi, metin: string) => {
    store.commit('setUyapStatusMessage', {
        type: tip,
        text: metin,
        timestamp: Date.now()
    });
});
